// Code generated by Tortuga protoc-gen-rest-ts. DO NOT EDIT.

/* eslint-disable */
import { ApiError } from "src/core/apiError";
import {
  ReST,
  generateQueryParams,
  generatePayload
} from "src/utils/api/rest/rest";
import { DashboardsResponse } from "src/gen/schema/configd/dashboard";
import { SetFabricConnectionsRequest } from "src/gen/schema/configd/rest_fabrics";
import { ManagementPortsResponse } from "src/gen/schema/configd/node";
import { CommitFabricCandidateRequest } from "src/gen/schema/configd/api";
import { GetDevicePsuModelsResponse } from "src/gen/schema/configd/api";
import { GetFabricVnisRequest } from "src/gen/schema/configd/rest_networks";
import { GetFabricBgpPeersRequest } from "src/gen/schema/configd/rest_bgp";
import { GetFabricStpRequest } from "src/gen/schema/configd/rest_fabrics";
import { GetSubInterfacesRequest } from "src/gen/schema/configd/api";
import { GetNotificationSettingsRequest } from "src/gen/schema/configd/endpoints";
import { GetFabricTemplatesResponse } from "src/gen/schema/configd/rest_fabrics";
import { AddFabricWithDesignResponse } from "src/gen/schema/configd/rest_fabrics";
import { UpdateFabricNodeRequest } from "src/gen/schema/configd/rest_node";
import { AddNodePortBreakoutsRequest } from "src/gen/schema/configd/rest_ports";
import { AddFabricDhcpRelaysRequest } from "src/gen/schema/configd/rest_networks";
import { GetOrgCertificatesRequest } from "src/gen/schema/configd/certificates";
import { CreateFabricBomEstimateResponse } from "src/gen/schema/configd/api";
import { GetManagementPortsRequest } from "src/gen/schema/configd/node";
import { BindDeviceRequest } from "src/gen/schema/configd/api";
import { UnbindDeviceRequest } from "src/gen/schema/configd/api";
import { CommitDciCandidateResponse } from "src/gen/schema/configd/api";
import { GetLimitsResponse } from "src/gen/schema/configd/api";
import { GetNodePortBreakoutsRequest } from "src/gen/schema/configd/rest_ports";
import { DscpConfig } from "src/gen/schema/models/qos";
import { SwitchGroupSoftwareConfig } from "src/gen/schema/models/image";
import { DeleteFabricDhcpRelayRequest } from "src/gen/schema/configd/rest_networks";
import { GetFabricIpSlaConfigRequest } from "src/gen/schema/configd/rest_networks";
import { UpdateSwitchGroupSoftwareTargetImageRequest } from "src/gen/schema/configd/image";
import { AgentConfigResponse } from "src/gen/schema/configd/onprem";
import { QueuedTask } from "src/gen/schema/configd/rest_queued_tasks";
import { UpdateFabricWithDesignRequest } from "src/gen/schema/configd/rest_fabrics";
import { GetNodeLoopbacksRequest } from "src/gen/schema/configd/rest_networks";
import { RefPoint } from "src/gen/schema/refpoints/refpoints";
import { ReviewDciCandidateRequest } from "src/gen/schema/configd/api";
import { Panel } from "src/gen/schema/models/dashboard";
import { GetLimitsRequest } from "src/gen/schema/configd/api";
import { GetLabelsRequest } from "src/gen/schema/configd/api";
import { UnclaimDeviceRequest } from "src/gen/schema/configd/api";
import { GetManagementPortRequest } from "src/gen/schema/configd/node";
import { GetFabricVniMemberRequest } from "src/gen/schema/configd/rest_networks";
import { UpdateNodeLoopbackRequest } from "src/gen/schema/configd/rest_networks";
import { DiffPart } from "src/gen/schema/refpoints/refpoints";
import { GetDevicePsuModelsRequest } from "src/gen/schema/configd/api";
import { GetFabricBomForEstimateRequest } from "src/gen/schema/configd/api";
import { DeleteFabricNodeRequest } from "src/gen/schema/configd/rest_node";
import { GetFabricDhcpRelaysRequest } from "src/gen/schema/configd/rest_networks";
import { FabricLoopbacksResponse } from "src/gen/schema/configd/rest_networks";
import { UpgradeOpticsFirmwareRequest } from "src/gen/schema/configd/image";
import { Dashboard } from "src/gen/schema/configd/dashboard";
import { AddFoldersRequest } from "src/gen/schema/configd/dashboard";
import { GetIpmConfigsRequest } from "src/gen/schema/configd/api";
import { GetEndpointsRequest } from "src/gen/schema/configd/endpoints";
import { GetFabricNotificationSettingsRequest } from "src/gen/schema/configd/endpoints";
import { GetFabricConfigRequest } from "src/gen/schema/configd/api";
import { BgpPolicy } from "src/gen/schema/models/routing";
import { GetDciConfigsRequest } from "src/gen/schema/configd/api";
import { GetPanelRequest } from "src/gen/schema/configd/dashboard";
import { GetCableModelsRequest } from "src/gen/schema/configd/api";
import { CreateFabricBomEstimateRequest } from "src/gen/schema/configd/api";
import { AddFabricBgpPoliciesRequest } from "src/gen/schema/configd/rest_bgp";
import { DeleteFabricStaticRouteRequest } from "src/gen/schema/configd/rest_networks";
import { FabricDhcpRelaysResponse } from "src/gen/schema/configd/rest_networks";
import { GetFabricDscpConfigRequest } from "src/gen/schema/configd/rest_networks";
import { DeleteFabricIpSlaConfigRequest } from "src/gen/schema/configd/rest_networks";
import { DashboardFoldersResponse } from "src/gen/schema/configd/dashboard";
import { UpdateEndpointRequest } from "src/gen/schema/configd/endpoints";
import { GetCablingPlanResponse } from "src/gen/schema/configd/rest_fabrics";
import { AddNodeLoopbacksRequest } from "src/gen/schema/configd/rest_networks";
import { DashboardPanel } from "src/gen/schema/configd/dashboard";
import { AddEndpointsRequest } from "src/gen/schema/configd/endpoints";
import { UpdateFabricStpRequest } from "src/gen/schema/configd/rest_fabrics";
import { GetFabricsRequest } from "src/gen/schema/configd/api";
import { ResolveTopologyRequest } from "src/gen/schema/configd/design";
import { GetFabricBgpPoliciesRequest } from "src/gen/schema/configd/rest_bgp";
import { FabricBgpPoliciesResponse } from "src/gen/schema/configd/rest_bgp";
import { DeleteFabricTargetImageRequest } from "src/gen/schema/configd/image";
import { ImportFabricResponse } from "src/gen/schema/configd/api";
import { GetCableModelsResponse } from "src/gen/schema/configd/api";
import { SyncPortStateResponse } from "src/gen/schema/configd/api";
import { GetFabricDscpConfigsRequest } from "src/gen/schema/configd/rest_networks";
import { GetFabricLoopbacksRequest } from "src/gen/schema/configd/rest_networks";
import { ProvisionSettingsRequest } from "src/gen/schema/configd/api";
import { MergeTopologyIntoFabricDesignResponse } from "src/gen/schema/configd/design";
import { ReviewFabricCandidateRequest } from "src/gen/schema/configd/api";
import { DeleteFabricConnectionRequest } from "src/gen/schema/configd/rest_fabrics";
import { SubInterface } from "src/gen/schema/models/models";
import { ExportedFabricRevision } from "src/gen/schema/configd/rest_fabrics";
import { UpdateFabricVrfRequest } from "src/gen/schema/configd/rest_networks";
import { GetStaticRoutesRequest } from "src/gen/schema/configd/api";
import { GetBmcConfigsRequest } from "src/gen/schema/configd/api";
import { GetBmcConfigsResponse } from "src/gen/schema/configd/api";
import { UpdateOrgCertificateResponse } from "src/gen/schema/configd/certificates";
import { GenerateCablingPlanResponse } from "src/gen/schema/configd/rest_fabrics";
import { GetNamedFabricNodeRequest } from "src/gen/schema/configd/rest_node";
import { BgpPeer } from "src/gen/schema/models/routing";
import { GetIpSlaConfigsRequest } from "src/gen/schema/configd/api";
import { GetLoopbacksRequest } from "src/gen/schema/configd/api";
import { GetFabricBomEstimatesRequest } from "src/gen/schema/configd/api";
import { DeleteFabricBgpPolicyRequest } from "src/gen/schema/configd/rest_bgp";
import { PerVlanStp } from "src/gen/schema/models/routing";
import { RestoreFabricRevisionRequest } from "src/gen/schema/configd/rest_fabrics";
import { ResendCodeForEndpointRequest } from "src/gen/schema/configd/endpoints";
import { GetFabricConfigResponse } from "src/gen/schema/configd/api";
import { DeleteFabricConnectionsRequest } from "src/gen/schema/configd/rest_fabrics";
import { UpdatePortRequest } from "src/gen/schema/configd/node";
import { UpdateFabricSoftwareNodeImagesRequest } from "src/gen/schema/configd/image";
import { GetDeletedFabricsResponse } from "src/gen/schema/configd/rest_fabrics";
import { CreateDeletedFabricExportRequest } from "src/gen/schema/configd/rest_fabrics";
import { GetFabricBomRequest } from "src/gen/schema/configd/api";
import { GetPortBreakoutsRequest } from "src/gen/schema/configd/api";
import { GetEndpointRequest } from "src/gen/schema/configd/endpoints";
import { GetOspfPeersRequest } from "src/gen/schema/configd/api";
import { GetFabricVniMembersResponse } from "src/gen/schema/configd/rest_networks";
import { Vni } from "src/gen/schema/models/models";
import { FabricStaticRoutesResponse } from "src/gen/schema/configd/rest_networks";
import { DeleteFabricDscpConfigRequest } from "src/gen/schema/configd/rest_networks";
import { RefPointByNameRequest } from "src/gen/schema/refpoints/refpoints";
import { GetFabricAssemblyResponse } from "src/gen/schema/configd/api";
import { FabricCandidate } from "src/gen/schema/configd/api";
import { PortBreakout } from "src/gen/schema/models/models";
import { DeleteNodeSubInterfaceRequest } from "src/gen/schema/configd/rest_networks";
import { FabricVnisResponse } from "src/gen/schema/configd/rest_networks";
import { StaticRoutes } from "src/gen/schema/models/models";
import { ProvisionRequest } from "src/gen/schema/configd/api";
import { GetDeviceModelsResponse } from "src/gen/schema/configd/api";
import { VerifyEndpointRequest } from "src/gen/schema/configd/endpoints";
import { DeleteEndpointRequest } from "src/gen/schema/configd/endpoints";
import { FabricIpSlaConfigsResponse } from "src/gen/schema/configd/rest_networks";
import { DeleteNodeLoopbackRequest } from "src/gen/schema/configd/rest_networks";
import { ExportedFabricConfiguration } from "src/gen/schema/configd/api";
import { GetDciCandidatesResponse } from "src/gen/schema/configd/api";
import { GetPacketMirroringsRequest } from "src/gen/schema/configd/api";
import { GetOrgCertificatesResponse } from "src/gen/schema/configd/certificates";
import { DeleteFabricNotificationSettingsRequest } from "src/gen/schema/configd/endpoints";
import { FabricRevisionIdResponse } from "src/gen/schema/configd/rest_fabrics";
import { GetPortRequest } from "src/gen/schema/configd/rest_ports";
import { BindDeviceResponse } from "src/gen/schema/configd/api";
import { GetOrgCertificateResponse } from "src/gen/schema/configd/certificates";
import { GetDeviceModelsRequest } from "src/gen/schema/configd/api";
import { GetFabricVrfsRequest } from "src/gen/schema/configd/rest_networks";
import { AddSwitchGroupSoftwareConfigRequest } from "src/gen/schema/configd/image";
import { ResolveTopologyResponse } from "src/gen/schema/configd/design";
import { GetFabricsResponse } from "src/gen/schema/configd/api";
import { GetNodesPortsRequest } from "src/gen/schema/configd/api";
import { GetOpticsFirmwareUpdateInfoRequest } from "src/gen/schema/configd/image";
import { UpdateManagementPortRequest } from "src/gen/schema/configd/node";
import { ProvisionSettingsResponse } from "src/gen/schema/configd/api";
import { GetFabricBomResponse } from "src/gen/schema/configd/api";
import { MergeTopologyIntoFabricDesignRequest } from "src/gen/schema/configd/design";
import { CloneFabricResponse } from "src/gen/schema/configd/rest_fabrics";
import { AddDashboardsRequest } from "src/gen/schema/configd/dashboard";
import { GetFabricInventoriesResponse } from "src/gen/schema/configd/api";
import { DeleteOrgCertificateRequest } from "src/gen/schema/configd/certificates";
import { GetFabricTemplateResponse } from "src/gen/schema/configd/rest_fabrics";
import { Node } from "src/gen/schema/configd/rest_node";
import { UpdateNodePortBreakoutRequest } from "src/gen/schema/configd/rest_ports";
import { GetFabricVniMembersRequest } from "src/gen/schema/configd/rest_networks";
import { Vrf } from "src/gen/schema/models/models";
import { AddFabricStaticRoutesRequest } from "src/gen/schema/configd/rest_networks";
import { GetVnisRequest } from "src/gen/schema/configd/api";
import { GenerateCablingPlanRequest } from "src/gen/schema/configd/rest_fabrics";
import { AddFabricWithDesignRequest } from "src/gen/schema/configd/rest_fabrics";
import { GetNodeSubInterfaceRequest } from "src/gen/schema/configd/rest_networks";
import { GetFabricVniRequest } from "src/gen/schema/configd/rest_networks";
import { UpdateFabricStaticRouteRequest } from "src/gen/schema/configd/rest_networks";
import { UpdateFabricIpSlaConfigRequest } from "src/gen/schema/configd/rest_networks";
import { AgentConfigRequest } from "src/gen/schema/configd/onprem";
import { GetFabricCandidatesRequest } from "src/gen/schema/configd/api";
import { GetFabricCandidateRequest } from "src/gen/schema/configd/api";
import { GetFabricBgpPeerRequest } from "src/gen/schema/configd/rest_bgp";
import { GetOpticsFirmwareUpdateInfoResponse } from "src/gen/schema/configd/image";
import { SetAgentPlatformInfoResponse } from "src/gen/schema/configd/onprem";
import { CreateFabricRevisionExportRequest } from "src/gen/schema/configd/rest_fabrics";
import { GetDeletedFabricsRequest } from "src/gen/schema/configd/rest_fabrics";
import { DashboardFolder } from "src/gen/schema/configd/dashboard";
import { TenantsObjectsResponse } from "src/gen/schema/configd/api";
import { GetFabricBomForEstimateResponse } from "src/gen/schema/configd/api";
import { GetFabricShareableLinkRequest } from "src/gen/schema/configd/rest_fabrics";
import { GetFabricVrfRequest } from "src/gen/schema/configd/rest_networks";
import { UpdateFabricDscpConfigRequest } from "src/gen/schema/configd/rest_networks";
import { UpdateFabricSoftwareRunningImageRequest } from "src/gen/schema/configd/image";
import { GetDeviceInventoriesRequest } from "src/gen/schema/configd/fabrics";
import { RestoreFabricRevisionResponse } from "src/gen/schema/configd/rest_fabrics";
import { AddPortChannelsRequest } from "src/gen/schema/configd/rest_fabrics";
import { DeletePortChannelRequest } from "src/gen/schema/configd/rest_fabrics";
import { GetFabricRevisionIdRequest } from "src/gen/schema/configd/rest_fabrics";
import { GetPrefixListsRequest } from "src/gen/schema/configd/api";
import { GetPrefixListsResponse } from "src/gen/schema/configd/api";
import { GetDciCandidatesRequest } from "src/gen/schema/configd/api";
import { GetDashboardsRequest } from "src/gen/schema/configd/dashboard";
import { UpdateFolderRequest } from "src/gen/schema/configd/dashboard";
import { SetNotificationSettingsRequest } from "src/gen/schema/configd/endpoints";
import { GetFabricTemplateRequest } from "src/gen/schema/configd/rest_fabrics";
import { NodePortBreakoutsResponse } from "src/gen/schema/configd/rest_ports";
import { DashboardPanels } from "src/gen/schema/configd/dashboard";
import { GetPortBreakoutsResponse } from "src/gen/schema/configd/api";
import { AddNodeSubInterfacesRequest } from "src/gen/schema/configd/rest_networks";
import { DeleteFabricVniMemberRequest } from "src/gen/schema/configd/rest_networks";
import { DeletePanelRequest } from "src/gen/schema/configd/dashboard";
import { GetFabricBomEstimatesResponse } from "src/gen/schema/configd/api";
import { NotificationSettingsResponse } from "src/gen/schema/configd/endpoints";
import { AddFabricNodesRequest } from "src/gen/schema/configd/rest_node";
import { GetFabricBgpPolicyRequest } from "src/gen/schema/configd/rest_bgp";
import { AddManagementPortsRequest } from "src/gen/schema/configd/node";
import { UpdateNodeSubInterfaceRequest } from "src/gen/schema/configd/rest_networks";
import { GetFabricSoftwareConfigRequest } from "src/gen/schema/configd/image";
import { AddPanelsRequest } from "src/gen/schema/configd/dashboard";
import { GetFabricAssemblyRequest } from "src/gen/schema/configd/api";
import { DeleteSwitchGroupTargetImageRequest } from "src/gen/schema/configd/image";
import { GetDciConfigsResponse } from "src/gen/schema/configd/api";
import { GetFabricDesignResponse } from "src/gen/schema/configd/api";
import { GetNodesRequest } from "src/gen/schema/configd/api";
import { UpdateOrgCertificateRequest } from "src/gen/schema/configd/certificates";
import { AddFabricBgpPeersRequest } from "src/gen/schema/configd/rest_bgp";
import { DeleteFabricBgpPeerRequest } from "src/gen/schema/configd/rest_bgp";
import { AddFabricVniMembersRequest } from "src/gen/schema/configd/rest_networks";
import { GetFabricStaticRouteRequest } from "src/gen/schema/configd/rest_networks";
import { CommitFabricCandidateResponse } from "src/gen/schema/configd/api";
import { GetFabricRequest } from "src/gen/schema/configd/rest_fabrics";
import { ResetPortRequest } from "src/gen/schema/configd/rest_ports";
import { DeleteFabricVrfRequest } from "src/gen/schema/configd/rest_networks";
import { GetFabricDhcpRelayRequest } from "src/gen/schema/configd/rest_networks";
import { RefPointList } from "src/gen/schema/refpoints/refpoints";
import { GetFabricMultisitesResponse } from "src/gen/schema/configd/api";
import { PortChannelsResponse } from "src/gen/schema/configd/rest_fabrics";
import { AddOrgCertificatesResponse } from "src/gen/schema/configd/certificates";
import { GetFabricIpSlaConfigsRequest } from "src/gen/schema/configd/rest_networks";
import { GetQueuedTasksResponse } from "src/gen/schema/configd/rest_queued_tasks";
import { GetQueuedTaskRequest } from "src/gen/schema/configd/rest_queued_tasks";
import { EndpointsResponse } from "src/gen/schema/configd/endpoints";
import { PortConnection } from "src/gen/schema/models/types";
import { AddFabricVrfsRequest } from "src/gen/schema/configd/rest_networks";
import { LatchAssertionsRequest } from "src/gen/schema/configd/assertions";
import { GetEntitlementUsageRequest } from "src/gen/schema/configd/entitlement";
import { RevertDciCandidateRequest } from "src/gen/schema/configd/api";
import { GetDscpConfigsRequest } from "src/gen/schema/configd/api";
import { GetOrgCertificateRequest } from "src/gen/schema/configd/certificates";
import { SetPortsRequest } from "src/gen/schema/configd/rest_ports";
import { UpdateFabricSoftwareTargetImageRequest } from "src/gen/schema/configd/image";
import { GetDashboardRequest } from "src/gen/schema/configd/dashboard";
import { GetAllPortChannelsRequest } from "src/gen/schema/configd/rest_fabrics";
import { GetNodeLoopbackRequest } from "src/gen/schema/configd/rest_networks";
import { SetAgentPlatformInfoRequest } from "src/gen/schema/configd/onprem";
import { GetFabricCandidatesResponse } from "src/gen/schema/configd/api";
import { AddFabricsRequest } from "src/gen/schema/configd/rest_fabrics";
import { CloneFabricRequest } from "src/gen/schema/configd/rest_fabrics";
import { ManagementPort } from "src/gen/schema/models/models";
import { FabricSoftwareConfig } from "src/gen/schema/models/image";
import { GetPortChannelsRequest } from "src/gen/schema/configd/api";
import { PortChannel } from "src/gen/schema/models/models";
import { RevertFabricCandidateRequest } from "src/gen/schema/configd/api";
import { UpdateFabricRequest } from "src/gen/schema/configd/rest_fabrics";
import { DeleteFabricRequest } from "src/gen/schema/configd/rest_fabrics";
import { VlanMember } from "src/gen/schema/models/types";
import { GetEntitlementUsageResponse } from "src/gen/schema/configd/entitlement";
import { GetArsConfigsRequest } from "src/gen/schema/configd/api";
import { GetFabricDesignRequest } from "src/gen/schema/configd/api";
import { ReviewFabricCandidateResponse } from "src/gen/schema/configd/api";
import { FabricConnectionsResponse } from "src/gen/schema/configd/rest_fabrics";
import { AddFabricDscpConfigsRequest } from "src/gen/schema/configd/rest_networks";
import { RefPointByFabricRequest } from "src/gen/schema/refpoints/refpoints";
import { GetVrfsRequest } from "src/gen/schema/configd/api";
import { GetPortChannelRequest } from "src/gen/schema/configd/rest_fabrics";
import { Certificates } from "src/gen/schema/models/types";
import { DeleteFabricSoftwareConfigRequest } from "src/gen/schema/configd/image";
import { CreateRefPointRequest } from "src/gen/schema/refpoints/refpoints";
import { GetFoldersRequest } from "src/gen/schema/configd/dashboard";
import { GetPanelsRequest } from "src/gen/schema/configd/dashboard";
import { UpdatePanelRequest } from "src/gen/schema/configd/dashboard";
import { GetDhcpRelaysRequest } from "src/gen/schema/configd/api";
import { GetNodesResponse } from "src/gen/schema/configd/api";
import { AddFabricVnisRequest } from "src/gen/schema/configd/rest_networks";
import { UpdateFabricSoftwareModeRequest } from "src/gen/schema/configd/image";
import { GetSwitchGroupSoftwareConfigRequest } from "src/gen/schema/configd/image";
import { UpgradeOpticsFirmwareResponse } from "src/gen/schema/configd/image";
import { GetFabricStaticRoutesRequest } from "src/gen/schema/configd/rest_networks";
import { GetLabelsResponse } from "src/gen/schema/configd/api";
import { GetActivityEventsResponse } from "src/gen/schema/configd/api";
import { GetMaterializedVniRequest } from "src/gen/schema/configd/api";
import { AddFabricNodesResponse } from "src/gen/schema/configd/rest_node";
import { FabricBgpPeersResponse } from "src/gen/schema/configd/rest_bgp";
import { UpdateFabricBgpPeerRequest } from "src/gen/schema/configd/rest_bgp";
import { UpdateFabricDhcpRelayRequest } from "src/gen/schema/configd/rest_networks";
import { VerifyEndpointCode } from "src/gen/schema/configd/endpoints";
import { DeleteFabricNodeImagesRequest } from "src/gen/schema/configd/image";
import { AssertionsResponse } from "src/gen/schema/configd/assertions";
import { LatchUnlatchAssertionsResponse } from "src/gen/schema/configd/rest_assertions";
import { ExportFabricConfigurationRequest } from "src/gen/schema/configd/api";
import { RestoreDeletedFabricRequest } from "src/gen/schema/configd/rest_fabrics";
import { FabricVrfsResponse } from "src/gen/schema/configd/rest_networks";
import { GetPerVlanStpRequest } from "src/gen/schema/configd/api";
import { GetBgpPeersRequest } from "src/gen/schema/configd/api";
import { GetNodesPortsResponse } from "src/gen/schema/configd/api";
import { Endpoint } from "src/gen/schema/models/endpoints";
import { GetAllFabricsResponse } from "src/gen/schema/configd/rest_fabrics";
import { GetPortsRequest } from "src/gen/schema/configd/rest_ports";
import { DeleteSwitchGroupSoftwareConfigRequest } from "src/gen/schema/configd/image";
import { GetFabricInventoriesRequest } from "src/gen/schema/configd/api";
import { GetFabricNodesRequest } from "src/gen/schema/configd/rest_node";
import { AddFabricConnectionsRequest } from "src/gen/schema/configd/rest_fabrics";
import { PortsResponse } from "src/gen/schema/configd/rest_ports";
import { NodeSubInterfacesResponse } from "src/gen/schema/configd/rest_networks";
import { GetSingleCredentialsRequest } from "src/gen/schema/configd/credentials";
import { GetQueuedTasksRequest } from "src/gen/schema/configd/rest_queued_tasks";
import { EchoResponse } from "src/gen/schema/common/echo";
import { AddFabricsResponse } from "src/gen/schema/configd/rest_fabrics";
import { GetNodeSubInterfacesRequest } from "src/gen/schema/configd/rest_networks";
import { NodeLoopbacksResponse } from "src/gen/schema/configd/rest_networks";
import { AddFabricSoftwareConfigRequest } from "src/gen/schema/configd/image";
import { UpdatePortChannelRequest } from "src/gen/schema/configd/rest_fabrics";
import { AddOrgCertificatesRequest } from "src/gen/schema/configd/certificates";
import { UpdateFabricBgpPolicyRequest } from "src/gen/schema/configd/rest_bgp";
import { GetBgpPoliciesRequest } from "src/gen/schema/configd/api";
import { GetFabricShareableLinkResponse } from "src/gen/schema/configd/rest_fabrics";
import { NetworkPort } from "src/gen/schema/models/models";
import { GetFabricMultisitesRequest } from "src/gen/schema/configd/api";
import { UpdateDashboardRequest } from "src/gen/schema/configd/dashboard";
import { DhcpRelay } from "src/gen/schema/models/models";
import { FabricDscpConfigsResponse } from "src/gen/schema/configd/rest_networks";
import { Loopback } from "src/gen/schema/models/models";
import { Credentials } from "src/gen/schema/models/types";
import { DeleteDashboardRequest } from "src/gen/schema/configd/dashboard";
import { GetServerMgmtCsvTemplateRequest } from "src/gen/schema/configd/api";
import { SyncPortStateRequest } from "src/gen/schema/configd/api";
import { NotificationSettings } from "src/gen/schema/models/endpoints";
import { ResetManagementPortRequest } from "src/gen/schema/configd/node";
import { ResetFabricStpRequest } from "src/gen/schema/configd/rest_fabrics";
import { IpSlaConfig } from "src/gen/schema/models/qos";
import { GetActivityEventsRequest } from "src/gen/schema/configd/api";
import { ProvisionResponse } from "src/gen/schema/configd/api";
import { GetPerVlanStpResponse } from "src/gen/schema/configd/api";
import { GetFabricNodesResponse } from "src/gen/schema/configd/rest_node";
import { GetFabricConnectionRequest } from "src/gen/schema/configd/rest_fabrics";
import { DeleteFabricRunningImageRequest } from "src/gen/schema/configd/image";
import { EchoRequest } from "src/gen/schema/common/echo";
import { GetAllFabricsRequest } from "src/gen/schema/configd/rest_fabrics";
import { GetCablingPlanRequest } from "src/gen/schema/configd/rest_fabrics";
import { GetFabricConnectionsRequest } from "src/gen/schema/configd/rest_fabrics";
import { DeleteNodePortBreakoutRequest } from "src/gen/schema/configd/rest_ports";
import { DeleteFabricVniRequest } from "src/gen/schema/configd/rest_networks";
import { CommitDciCandidateRequest } from "src/gen/schema/configd/api";
import { ClaimDevicesRequest } from "src/gen/schema/configd/api";
import { ClaimDevicesResponse } from "src/gen/schema/configd/api";
import { GetFabricTemplatesRequest } from "src/gen/schema/configd/rest_fabrics";
import { GetNodePortBreakoutRequest } from "src/gen/schema/configd/rest_ports";
import { AddFabricIpSlaConfigsRequest } from "src/gen/schema/configd/rest_networks";
import { LatchUnlatchAssertionsRequest } from "src/gen/schema/configd/rest_assertions";
import { Fabric } from "src/gen/schema/configd/rest_fabrics";
import { UpdateFabricVniRequest } from "src/gen/schema/configd/rest_networks";
import { GetDeviceInventoriesResponse } from "src/gen/schema/configd/fabrics";

export const ConfigD = {
  echo: (
    request: EchoRequest,
    options?: RequestInit | undefined
  ): Promise<EchoResponse> => {
    return ReST.post(
      `/api/v1/hidden/echo/configd`,
      generatePayload(request, EchoRequest),
      options
    ).then((response) => response.json())
      .then(EchoResponse.fromJSON);
  },
  getLimits: (
    request: GetLimitsRequest,
    options?: RequestInit | undefined
  ): Promise<GetLimitsResponse> => {
    //Generate query params
    const queryParams = generateQueryParams(
      request
    );
    return ReST.get(
      `/api/v1/limits${queryParams}`,
      options
    ).then((response) => response.json())
      .then(GetLimitsResponse.fromJSON);
  },
  getLabels: (
    request: GetLabelsRequest,
    options?: RequestInit | undefined
  ): Promise<GetLabelsResponse> => {
    //Generate query params
    const queryParams = generateQueryParams(
      request
    );
    return ReST.get(
      `/api/v1/labels${queryParams}`,
      options
    ).then((response) => response.json())
      .then(GetLabelsResponse.fromJSON);
  },
  getActivityEvents: (
    request: GetActivityEventsRequest,
    options?: RequestInit | undefined
  ): Promise<GetActivityEventsResponse> => {
    //Generate query params
    const queryParams = generateQueryParams(
      request
    );
    return ReST.get(
      `/api/v1/events${queryParams}`,
      options
    ).then((response) => response.json())
      .then(GetActivityEventsResponse.fromJSON);
  },
  provisionCreate: (
    request: ProvisionRequest,
    options?: RequestInit | undefined
  ): Promise<ProvisionResponse> => {
    return ReST.post(
      `/api/v1/provision`,
      generatePayload(request, ProvisionRequest),
      options
    ).then((response) => response.json())
      .then(ProvisionResponse.fromJSON);
  },
  provisionUpdate: (
    request: ProvisionRequest,
    options?: RequestInit | undefined
  ): Promise<ProvisionResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    return ReST.put(
      `/api/v1/provision/${request.fabricId}`,
      generatePayload(request, ProvisionRequest),
      options
    ).then((response) => response.json())
      .then(ProvisionResponse.fromJSON);
  },
  provisionSettings: (
    request: ProvisionSettingsRequest,
    options?: RequestInit | undefined
  ): Promise<ProvisionSettingsResponse> => {
    return ReST.put(
      `/api/v1/provisionSettings`,
      generatePayload(request, ProvisionSettingsRequest),
      options
    ).then((response) => response.json())
      .then(ProvisionSettingsResponse.fromJSON);
  },
  getFabricInventories: (
    request: GetFabricInventoriesRequest,
    options?: RequestInit | undefined
  ): Promise<GetFabricInventoriesResponse> => {
    //Generate query params
    const queryParams = generateQueryParams(
      request
    );
    return ReST.get(
      `/api/v1/inventories${queryParams}`,
      options
    ).then((response) => response.json())
      .then(GetFabricInventoriesResponse.fromJSON);
  },
  getFabricAssembly: (
    request: GetFabricAssemblyRequest,
    options?: RequestInit | undefined
  ): Promise<GetFabricAssemblyResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId"]
    );
    return ReST.get(
      `/api/v1/fabrics/${request.fabricId}/parts${queryParams}`,
      options
    ).then((response) => response.json())
      .then(GetFabricAssemblyResponse.fromJSON);
  },
  getFabricBom: (
    request: GetFabricBomRequest,
    options?: RequestInit | undefined
  ): Promise<GetFabricBomResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId"]
    );
    return ReST.get(
      `/api/v1/fabrics/${request.fabricId}/billOfMaterials${queryParams}`,
      options
    ).then((response) => response.json())
      .then(GetFabricBomResponse.fromJSON);
  },
  getIpmConfigs: (
    request: GetIpmConfigsRequest,
    options?: RequestInit | undefined
  ): Promise<TenantsObjectsResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId"]
    );
    return ReST.get(
      `/api/v1/fabrics/${request.fabricId}/ipmConfigs${queryParams}`,
      options
    ).then((response) => response.json())
      .then(TenantsObjectsResponse.fromJSON);
  },
  getDscpConfigs: (
    request: GetDscpConfigsRequest,
    options?: RequestInit | undefined
  ): Promise<TenantsObjectsResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId"]
    );
    return ReST.get(
      `/ui/v1/fabrics/${request.fabricId}/dscpConfigs${queryParams}`,
      options
    ).then((response) => response.json())
      .then(TenantsObjectsResponse.fromJSON);
  },
  getPacketMirrorings: (
    request: GetPacketMirroringsRequest,
    options?: RequestInit | undefined
  ): Promise<TenantsObjectsResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId"]
    );
    return ReST.get(
      `/api/v1/fabrics/${request.fabricId}/packetMirrorings${queryParams}`,
      options
    ).then((response) => response.json())
      .then(TenantsObjectsResponse.fromJSON);
  },
  getIpSlaConfigs: (
    request: GetIpSlaConfigsRequest,
    options?: RequestInit | undefined
  ): Promise<TenantsObjectsResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId"]
    );
    return ReST.get(
      `/ui/v1/fabrics/${request.fabricId}/ipSlaConfigs${queryParams}`,
      options
    ).then((response) => response.json())
      .then(TenantsObjectsResponse.fromJSON);
  },
  getArsConfigs: (
    request: GetArsConfigsRequest,
    options?: RequestInit | undefined
  ): Promise<TenantsObjectsResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId"]
    );
    return ReST.get(
      `/api/v1/fabrics/${request.fabricId}/arsConfigs${queryParams}`,
      options
    ).then((response) => response.json())
      .then(TenantsObjectsResponse.fromJSON);
  },
  getVnis: (
    request: GetVnisRequest,
    options?: RequestInit | undefined
  ): Promise<TenantsObjectsResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId"]
    );
    return ReST.get(
      `/ui/v1/fabrics/${request.fabricId}/vnis${queryParams}`,
      options
    ).then((response) => response.json())
      .then(TenantsObjectsResponse.fromJSON);
  },
  getMaterializedVni: (
    request: GetMaterializedVniRequest,
    options?: RequestInit | undefined
  ): Promise<TenantsObjectsResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId"]
    );
    return ReST.get(
      `/ui/v1/fabrics/${request.fabricId}/materializedVni${queryParams}`,
      options
    ).then((response) => response.json())
      .then(TenantsObjectsResponse.fromJSON);
  },
  getVrfs: (
    request: GetVrfsRequest,
    options?: RequestInit | undefined
  ): Promise<TenantsObjectsResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId"]
    );
    return ReST.get(
      `/ui/v1/fabrics/${request.fabricId}/vrfs${queryParams}`,
      options
    ).then((response) => response.json())
      .then(TenantsObjectsResponse.fromJSON);
  },
  getStaticRoutes: (
    request: GetStaticRoutesRequest,
    options?: RequestInit | undefined
  ): Promise<TenantsObjectsResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId"]
    );
    return ReST.get(
      `/ui/v1/fabrics/${request.fabricId}/staticRoutes${queryParams}`,
      options
    ).then((response) => response.json())
      .then(TenantsObjectsResponse.fromJSON);
  },
  getDhcpRelays: (
    request: GetDhcpRelaysRequest,
    options?: RequestInit | undefined
  ): Promise<TenantsObjectsResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId"]
    );
    return ReST.get(
      `/ui/v1/fabrics/${request.fabricId}/dhcpRelays${queryParams}`,
      options
    ).then((response) => response.json())
      .then(TenantsObjectsResponse.fromJSON);
  },
  getLoopbacks: (
    request: GetLoopbacksRequest,
    options?: RequestInit | undefined
  ): Promise<TenantsObjectsResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId"]
    );
    return ReST.get(
      `/ui/v1/fabrics/${request.fabricId}/tenants/loopbacks${queryParams}`,
      options
    ).then((response) => response.json())
      .then(TenantsObjectsResponse.fromJSON);
  },
  getPortChannels: (
    request: GetPortChannelsRequest,
    options?: RequestInit | undefined
  ): Promise<TenantsObjectsResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId"]
    );
    return ReST.get(
      `/ui/v1/fabrics/${request.fabricId}/portChannels${queryParams}`,
      options
    ).then((response) => response.json())
      .then(TenantsObjectsResponse.fromJSON);
  },
  getAllPortChannels: (
    request: GetAllPortChannelsRequest,
    options?: RequestInit | undefined
  ): Promise<PortChannelsResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId"]
    );
    return ReST.get(
      `/api/v1/fabrics/${request.fabricId}/portChannels${queryParams}`,
      options
    ).then((response) => response.json())
      .then(PortChannelsResponse.fromJSON);
  },
  getPortChannel: (
    request: GetPortChannelRequest,
    options?: RequestInit | undefined
  ): Promise<PortChannel> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: id
    if (!request.id) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.id is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId", "id"]
    );
    return ReST.get(
      `/api/v1/fabrics/${request.fabricId}/portChannels/${request.id}${queryParams}`,
      options
    ).then((response) => response.json())
      .then(PortChannel.fromJSON);
  },
  addPortChannels: (
    request: AddPortChannelsRequest,
    options?: RequestInit | undefined
  ): Promise<PortChannelsResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    return ReST.post(
      `/api/v1/fabrics/${request.fabricId}/portChannels`,
      generatePayload(request, AddPortChannelsRequest),
      options
    ).then((response) => response.json())
      .then(PortChannelsResponse.fromJSON);
  },
  updatePortChannel: (
    request: UpdatePortChannelRequest,
    options?: RequestInit | undefined
  ): Promise<PortChannel> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: id
    if (!request.id) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.id is invalid.")
      );
    }
    //Validate Body Annotation Field
    if (!request.portChannel) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.portChannel is invalid.")
      );
    }
    return ReST.put(
      `/api/v1/fabrics/${request.fabricId}/portChannels/${request.id}`,
      generatePayload(request, PortChannel, "portChannel"),
      options
    ).then((response) => response.json())
      .then(PortChannel.fromJSON);
  },
  deletePortChannel: (
    request: DeletePortChannelRequest,
    options?: RequestInit | undefined
  ): Promise<Response> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: id
    if (!request.id) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.id is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId", "id"]
    );
    return ReST.delete(
      `/api/v1/fabrics/${request.fabricId}/portChannels/${request.id}${queryParams}`,
      options
    );
  },
  getSubInterfaces: (
    request: GetSubInterfacesRequest,
    options?: RequestInit | undefined
  ): Promise<TenantsObjectsResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId"]
    );
    return ReST.get(
      `/ui/v1/fabrics/${request.fabricId}/subInterfaces${queryParams}`,
      options
    ).then((response) => response.json())
      .then(TenantsObjectsResponse.fromJSON);
  },
  getPerVlanStp: (
    request: GetPerVlanStpRequest,
    options?: RequestInit | undefined
  ): Promise<GetPerVlanStpResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId"]
    );
    return ReST.get(
      `/ui/v1/fabrics/${request.fabricId}/stp${queryParams}`,
      options
    ).then((response) => response.json())
      .then(GetPerVlanStpResponse.fromJSON);
  },
  getBgpPeers: (
    request: GetBgpPeersRequest,
    options?: RequestInit | undefined
  ): Promise<TenantsObjectsResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId"]
    );
    return ReST.get(
      `/ui/v1/fabrics/${request.fabricId}/bgpPeers${queryParams}`,
      options
    ).then((response) => response.json())
      .then(TenantsObjectsResponse.fromJSON);
  },
  getBgpPolicies: (
    request: GetBgpPoliciesRequest,
    options?: RequestInit | undefined
  ): Promise<TenantsObjectsResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId"]
    );
    return ReST.get(
      `/ui/v1/fabrics/${request.fabricId}/bgpPolicies${queryParams}`,
      options
    ).then((response) => response.json())
      .then(TenantsObjectsResponse.fromJSON);
  },
  getFabrics: (
    request: GetFabricsRequest,
    options?: RequestInit | undefined
  ): Promise<GetFabricsResponse> => {
    //Generate query params
    const queryParams = generateQueryParams(
      request
    );
    return ReST.get(
      `/ui/v1/fabrics${queryParams}`,
      options
    ).then((response) => response.json())
      .then(GetFabricsResponse.fromJSON);
  },
  getFabricDesigns: (
    request: GetFabricDesignRequest,
    options?: RequestInit | undefined
  ): Promise<GetFabricDesignResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId"]
    );
    return ReST.get(
      `/api/v1/fabrics/${request.fabricId}/designs${queryParams}`,
      options
    ).then((response) => response.json())
      .then(GetFabricDesignResponse.fromJSON);
  },
  mergeTopologyIntoFabricDesign: (
    request: MergeTopologyIntoFabricDesignRequest,
    options?: RequestInit | undefined
  ): Promise<MergeTopologyIntoFabricDesignResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    return ReST.post(
      `/ui/v1/fabrics/${request.fabricId}/designFromTopology`,
      generatePayload(request, MergeTopologyIntoFabricDesignRequest),
      options
    ).then((response) => response.json())
      .then(MergeTopologyIntoFabricDesignResponse.fromJSON);
  },
  mergeTopologyIntoNewFabricDesign: (
    request: MergeTopologyIntoFabricDesignRequest,
    options?: RequestInit | undefined
  ): Promise<MergeTopologyIntoFabricDesignResponse> => {
    return ReST.post(
      `/ui/v1/fabricDesigns`,
      generatePayload(request, MergeTopologyIntoFabricDesignRequest),
      options
    ).then((response) => response.json())
      .then(MergeTopologyIntoFabricDesignResponse.fromJSON);
  },
  resolveTopology: (
    request: ResolveTopologyRequest,
    options?: RequestInit | undefined
  ): Promise<ResolveTopologyResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    return ReST.post(
      `/ui/v1/fabrics/${request.fabricId}/resolveTopology`,
      generatePayload(request, ResolveTopologyRequest),
      options
    ).then((response) => response.json())
      .then(ResolveTopologyResponse.fromJSON);
  },
  getFabricCandidates: (
    request: GetFabricCandidatesRequest,
    options?: RequestInit | undefined
  ): Promise<GetFabricCandidatesResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId"]
    );
    return ReST.get(
      `/api/v1/fabrics/${request.fabricId}/candidates${queryParams}`,
      options
    ).then((response) => response.json())
      .then(GetFabricCandidatesResponse.fromJSON);
  },
  getFabricCandidate: (
    request: GetFabricCandidateRequest,
    options?: RequestInit | undefined
  ): Promise<FabricCandidate> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: name
    if (!request.name) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.name is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId", "name"]
    );
    return ReST.get(
      `/api/v1/fabrics/${request.fabricId}/candidates/${request.name}${queryParams}`,
      options
    ).then((response) => response.json())
      .then(FabricCandidate.fromJSON);
  },
  commitFabricCandidate: (
    request: CommitFabricCandidateRequest,
    options?: RequestInit | undefined
  ): Promise<CommitFabricCandidateResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: name
    if (!request.name) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.name is invalid.")
      );
    }
    return ReST.post(
      `/api/v1/fabrics/${request.fabricId}/candidates/${request.name}`,
      generatePayload(request, CommitFabricCandidateRequest),
      options
    ).then((response) => response.json())
      .then(CommitFabricCandidateResponse.fromJSON);
  },
  revertFabricCandidate: (
    request: RevertFabricCandidateRequest,
    options?: RequestInit | undefined
  ): Promise<Response> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: name
    if (!request.name) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.name is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId", "name"]
    );
    return ReST.delete(
      `/api/v1/fabrics/${request.fabricId}/candidates/${request.name}${queryParams}`,
      options
    );
  },
  reviewFabricCandidate: (
    request: ReviewFabricCandidateRequest,
    options?: RequestInit | undefined
  ): Promise<ReviewFabricCandidateResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: name
    if (!request.name) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.name is invalid.")
      );
    }
    return ReST.put(
      `/api/v1/fabrics/${request.fabricId}/candidates/${request.name}`,
      generatePayload(request, ReviewFabricCandidateRequest),
      options
    ).then((response) => response.json())
      .then(ReviewFabricCandidateResponse.fromJSON);
  },
  getNodes: (
    request: GetNodesRequest,
    options?: RequestInit | undefined
  ): Promise<GetNodesResponse> => {
    //Generate query params
    const queryParams = generateQueryParams(
      request
    );
    return ReST.get(
      `/ui/v1/nodes${queryParams}`,
      options
    ).then((response) => response.json())
      .then(GetNodesResponse.fromJSON);
  },
  claimDevices: (
    request: ClaimDevicesRequest,
    options?: RequestInit | undefined
  ): Promise<ClaimDevicesResponse> => {
    return ReST.post(
      `/api/v1/devices`,
      generatePayload(request, ClaimDevicesRequest),
      options
    ).then((response) => response.json())
      .then(ClaimDevicesResponse.fromJSON);
  },
  unclaimDevice: (
    request: UnclaimDeviceRequest,
    options?: RequestInit | undefined
  ): Promise<Response> => {
    //Validate Path Param: deviceId
    if (!request.deviceId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.deviceId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["deviceId"]
    );
    return ReST.delete(
      `/api/v1/devices/${request.deviceId}${queryParams}`,
      options
    );
  },
  getNodesPorts: (
    request: GetNodesPortsRequest,
    options?: RequestInit | undefined
  ): Promise<GetNodesPortsResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId"]
    );
    return ReST.get(
      `/ui/v1/fabrics/${request.fabricId}/ports${queryParams}`,
      options
    ).then((response) => response.json())
      .then(GetNodesPortsResponse.fromJSON);
  },
  getPortBreakouts: (
    request: GetPortBreakoutsRequest,
    options?: RequestInit | undefined
  ): Promise<GetPortBreakoutsResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId"]
    );
    return ReST.get(
      `/ui/v1/fabrics/${request.fabricId}/portBreakouts${queryParams}`,
      options
    ).then((response) => response.json())
      .then(GetPortBreakoutsResponse.fromJSON);
  },
  getBmcConfigs: (
    request: GetBmcConfigsRequest,
    options?: RequestInit | undefined
  ): Promise<GetBmcConfigsResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId"]
    );
    return ReST.get(
      `/ui/v1/fabrics/${request.fabricId}/bmcConfigs${queryParams}`,
      options
    ).then((response) => response.json())
      .then(GetBmcConfigsResponse.fromJSON);
  },
  getOrgCertificates: (
    request: GetOrgCertificatesRequest,
    options?: RequestInit | undefined
  ): Promise<GetOrgCertificatesResponse> => {
    //Generate query params
    const queryParams = generateQueryParams(
      request
    );
    return ReST.get(
      `/api/v1/certificates${queryParams}`,
      options
    ).then((response) => response.json())
      .then(GetOrgCertificatesResponse.fromJSON);
  },
  getOrgCertificate: (
    request: GetOrgCertificateRequest,
    options?: RequestInit | undefined
  ): Promise<GetOrgCertificateResponse> => {
    //Validate Path Param: certificateId
    if (!request.certificateId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.certificateId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["certificateId"]
    );
    return ReST.get(
      `/api/v1/certificates/${request.certificateId}${queryParams}`,
      options
    ).then((response) => response.json())
      .then(GetOrgCertificateResponse.fromJSON);
  },
  addOrgCertificates: (
    request: AddOrgCertificatesRequest,
    options?: RequestInit | undefined
  ): Promise<AddOrgCertificatesResponse> => {
    //Validate Body Annotation Field
    if (!request.certificates) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.certificates is invalid.")
      );
    }
    return ReST.post(
      `/api/v1/certificates`,
      generatePayload(request, Certificates, "certificates"),
      options
    ).then((response) => response.json())
      .then(AddOrgCertificatesResponse.fromJSON);
  },
  updateOrgCertificate: (
    request: UpdateOrgCertificateRequest,
    options?: RequestInit | undefined
  ): Promise<UpdateOrgCertificateResponse> => {
    //Validate Path Param: certificateId
    if (!request.certificateId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.certificateId is invalid.")
      );
    }
    //Validate Body Annotation Field
    if (!request.certificate) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.certificate is invalid.")
      );
    }
    return ReST.put(
      `/api/v1/certificates/${request.certificateId}`,
      generatePayload(request, Certificates, "certificate"),
      options
    ).then((response) => response.json())
      .then(UpdateOrgCertificateResponse.fromJSON);
  },
  deleteOrgCertificate: (
    request: DeleteOrgCertificateRequest,
    options?: RequestInit | undefined
  ): Promise<Response> => {
    //Validate Path Param: certificateId
    if (!request.certificateId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.certificateId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["certificateId"]
    );
    return ReST.delete(
      `/api/v1/certificates/${request.certificateId}${queryParams}`,
      options
    );
  },
  getDeviceModels: (
    request: GetDeviceModelsRequest,
    options?: RequestInit | undefined
  ): Promise<GetDeviceModelsResponse> => {
    //Generate query params
    const queryParams = generateQueryParams(
      request
    );
    return ReST.get(
      `/api/v1/deviceModels${queryParams}`,
      options
    ).then((response) => response.json())
      .then(GetDeviceModelsResponse.fromJSON);
  },
  getCableModels: (
    request: GetCableModelsRequest,
    options?: RequestInit | undefined
  ): Promise<GetCableModelsResponse> => {
    //Generate query params
    const queryParams = generateQueryParams(
      request
    );
    return ReST.get(
      `/api/v1/cableModels${queryParams}`,
      options
    ).then((response) => response.json())
      .then(GetCableModelsResponse.fromJSON);
  },
  getDevicePsuModels: (
    request: GetDevicePsuModelsRequest,
    options?: RequestInit | undefined
  ): Promise<GetDevicePsuModelsResponse> => {
    //Generate query params
    const queryParams = generateQueryParams(
      request
    );
    return ReST.get(
      `/api/v1/devicePsuModels${queryParams}`,
      options
    ).then((response) => response.json())
      .then(GetDevicePsuModelsResponse.fromJSON);
  },
  getServerMgmtCsvTemplate: (
    request: GetServerMgmtCsvTemplateRequest,
    options?: RequestInit | undefined
  ): Promise<Response> => {
    //Validate Path Param: modelName
    if (!request.modelName) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.modelName is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["modelName"]
    );
    return ReST.get(
      `/api/v1/deviceModels/${request.modelName}/mgmtCsvTemplate${queryParams}`,
      options
    );
  },
  syncPortState: (
    request: SyncPortStateRequest,
    options?: RequestInit | undefined
  ): Promise<SyncPortStateResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: nodeId
    if (!request.nodeId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.nodeId is invalid.")
      );
    }
    //Validate Path Param: name
    if (!request.name) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.name is invalid.")
      );
    }
    return ReST.post(
      `/api/v1/fabrics/${request.fabricId}/nodes/${request.nodeId}/ports/${request.name}`,
      generatePayload(request, SyncPortStateRequest),
      options
    ).then((response) => response.json())
      .then(SyncPortStateResponse.fromJSON);
  },
  createFabricBomEstimate: (
    request: CreateFabricBomEstimateRequest,
    options?: RequestInit | undefined
  ): Promise<CreateFabricBomEstimateResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    return ReST.post(
      `/ui/v1/fabrics/${request.fabricId}/estimates`,
      generatePayload(request, CreateFabricBomEstimateRequest),
      options
    ).then((response) => response.json())
      .then(CreateFabricBomEstimateResponse.fromJSON);
  },
  getFabricBomEstimates: (
    request: GetFabricBomEstimatesRequest,
    options?: RequestInit | undefined
  ): Promise<GetFabricBomEstimatesResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId"]
    );
    return ReST.get(
      `/ui/v1/fabrics/${request.fabricId}/estimates${queryParams}`,
      options
    ).then((response) => response.json())
      .then(GetFabricBomEstimatesResponse.fromJSON);
  },
  getFabricBomForEstimate: (
    request: GetFabricBomForEstimateRequest,
    options?: RequestInit | undefined
  ): Promise<GetFabricBomForEstimateResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: estimateId
    if (!request.estimateId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.estimateId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId", "estimateId"]
    );
    return ReST.get(
      `/ui/v1/fabrics/${request.fabricId}/estimates/${request.estimateId}/billOfMaterials${queryParams}`,
      options
    ).then((response) => response.json())
      .then(GetFabricBomForEstimateResponse.fromJSON);
  },
  getEndpoints: (
    request: GetEndpointsRequest,
    options?: RequestInit | undefined
  ): Promise<EndpointsResponse> => {
    //Generate query params
    const queryParams = generateQueryParams(
      request
    );
    return ReST.get(
      `/api/v1/notificationEndpoints${queryParams}`,
      options
    ).then((response) => response.json())
      .then(EndpointsResponse.fromJSON);
  },
  getEndpoint: (
    request: GetEndpointRequest,
    options?: RequestInit | undefined
  ): Promise<Endpoint> => {
    //Validate Path Param: endpointId
    if (!request.endpointId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.endpointId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["endpointId"]
    );
    return ReST.get(
      `/api/v1/notificationEndpoints/${request.endpointId}${queryParams}`,
      options
    ).then((response) => response.json())
      .then(Endpoint.fromJSON);
  },
  addEndpoints: (
    request: AddEndpointsRequest,
    options?: RequestInit | undefined
  ): Promise<EndpointsResponse> => {
    return ReST.post(
      `/api/v1/notificationEndpoints`,
      generatePayload(request, AddEndpointsRequest),
      options
    ).then((response) => response.json())
      .then(EndpointsResponse.fromJSON);
  },
  updateEndpoint: (
    request: UpdateEndpointRequest,
    options?: RequestInit | undefined
  ): Promise<Endpoint> => {
    //Validate Path Param: endpointId
    if (!request.endpointId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.endpointId is invalid.")
      );
    }
    //Validate Body Annotation Field
    if (!request.endpoint) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.endpoint is invalid.")
      );
    }
    return ReST.put(
      `/api/v1/notificationEndpoints/${request.endpointId}`,
      generatePayload(request, Endpoint, "endpoint"),
      options
    ).then((response) => response.json())
      .then(Endpoint.fromJSON);
  },
  verifyEndpoint: (
    request: VerifyEndpointRequest,
    options?: RequestInit | undefined
  ): Promise<Endpoint> => {
    //Validate Path Param: endpointId
    if (!request.endpointId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.endpointId is invalid.")
      );
    }
    //Validate Body Annotation Field
    if (!request.code) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.code is invalid.")
      );
    }
    return ReST.put(
      `/api/v1/notificationEndpoints/${request.endpointId}/codes`,
      generatePayload(request, VerifyEndpointCode, "code"),
      options
    ).then((response) => response.json())
      .then(Endpoint.fromJSON);
  },
  resendCodeForEndpoint: (
    request: ResendCodeForEndpointRequest,
    options?: RequestInit | undefined
  ): Promise<Response> => {
    //Validate Path Param: endpointId
    if (!request.endpointId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.endpointId is invalid.")
      );
    }
    return ReST.post(
      `/api/v1/notificationEndpoints/${request.endpointId}/codes`,
      generatePayload(request, ResendCodeForEndpointRequest),
      options
    );
  },
  deleteEndpoint: (
    request: DeleteEndpointRequest,
    options?: RequestInit | undefined
  ): Promise<Response> => {
    //Validate Path Param: endpointId
    if (!request.endpointId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.endpointId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["endpointId"]
    );
    return ReST.delete(
      `/api/v1/notificationEndpoints/${request.endpointId}${queryParams}`,
      options
    );
  },
  getNotificationSettings: (
    request: GetNotificationSettingsRequest,
    options?: RequestInit | undefined
  ): Promise<NotificationSettingsResponse> => {
    //Generate query params
    const queryParams = generateQueryParams(
      request
    );
    return ReST.get(
      `/api/v1/notificationSettings${queryParams}`,
      options
    ).then((response) => response.json())
      .then(NotificationSettingsResponse.fromJSON);
  },
  setNotificationSettings: (
    request: SetNotificationSettingsRequest,
    options?: RequestInit | undefined
  ): Promise<NotificationSettingsResponse> => {
    return ReST.put(
      `/api/v1/notificationSettings`,
      generatePayload(request, SetNotificationSettingsRequest),
      options
    ).then((response) => response.json())
      .then(NotificationSettingsResponse.fromJSON);
  },
  getFabricNotificationSettings: (
    request: GetFabricNotificationSettingsRequest,
    options?: RequestInit | undefined
  ): Promise<NotificationSettings> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId"]
    );
    return ReST.get(
      `/api/v1/fabrics/${request.fabricId}/notificationSettings${queryParams}`,
      options
    ).then((response) => response.json())
      .then(NotificationSettings.fromJSON);
  },
  setFabricNotificationSettings: (
    request: NotificationSettings,
    options?: RequestInit | undefined
  ): Promise<NotificationSettings> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    return ReST.put(
      `/api/v1/fabrics/${request.fabricId}/notificationSettings`,
      generatePayload(request, NotificationSettings),
      options
    ).then((response) => response.json())
      .then(NotificationSettings.fromJSON);
  },
  deleteFabricNotificationSettings: (
    request: DeleteFabricNotificationSettingsRequest,
    options?: RequestInit | undefined
  ): Promise<Response> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId"]
    );
    return ReST.delete(
      `/api/v1/fabrics/${request.fabricId}/notificationSettings${queryParams}`,
      options
    );
  },
  getFabricRevisionId: (
    request: GetFabricRevisionIdRequest,
    options?: RequestInit | undefined
  ): Promise<FabricRevisionIdResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId"]
    );
    return ReST.get(
      `/api/v1/fabrics/${request.fabricId}/revisionIds${queryParams}`,
      options
    ).then((response) => response.json())
      .then(FabricRevisionIdResponse.fromJSON);
  },
  getAllFabrics: (
    request: GetAllFabricsRequest,
    options?: RequestInit | undefined
  ): Promise<GetAllFabricsResponse> => {
    //Generate query params
    const queryParams = generateQueryParams(
      request
    );
    return ReST.get(
      `/api/v1/fabrics${queryParams}`,
      options
    ).then((response) => response.json())
      .then(GetAllFabricsResponse.fromJSON);
  },
  getFabric: (
    request: GetFabricRequest,
    options?: RequestInit | undefined
  ): Promise<Fabric> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId"]
    );
    return ReST.get(
      `/api/v1/fabrics/${request.fabricId}${queryParams}`,
      options
    ).then((response) => response.json())
      .then(Fabric.fromJSON);
  },
  getFabricShareableLink: (
    request: GetFabricShareableLinkRequest,
    options?: RequestInit | undefined
  ): Promise<GetFabricShareableLinkResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId"]
    );
    return ReST.get(
      `/api/v1/fabrics/${request.fabricId}/shareableLink${queryParams}`,
      options
    ).then((response) => response.json())
      .then(GetFabricShareableLinkResponse.fromJSON);
  },
  getFabricConfig: (
    request: GetFabricConfigRequest,
    options?: RequestInit | undefined
  ): Promise<GetFabricConfigResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId"]
    );
    return ReST.get(
      `/ui/v1/fabrics/${request.fabricId}/configurations${queryParams}`,
      options
    ).then((response) => response.json())
      .then(GetFabricConfigResponse.fromJSON);
  },
  getFabricTemplates: (
    request: GetFabricTemplatesRequest,
    options?: RequestInit | undefined
  ): Promise<GetFabricTemplatesResponse> => {
    //Generate query params
    const queryParams = generateQueryParams(
      request
    );
    return ReST.get(
      `/api/v1/fabricTemplates${queryParams}`,
      options
    ).then((response) => response.json())
      .then(GetFabricTemplatesResponse.fromJSON);
  },
  getFabricTemplate: (
    request: GetFabricTemplateRequest,
    options?: RequestInit | undefined
  ): Promise<GetFabricTemplateResponse> => {
    //Validate Path Param: templateId
    if (!request.templateId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.templateId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["templateId"]
    );
    return ReST.get(
      `/api/v1/fabricTemplates/${request.templateId}${queryParams}`,
      options
    ).then((response) => response.json())
      .then(GetFabricTemplateResponse.fromJSON);
  },
  generateCablingPlanFromDesign: (
    request: GenerateCablingPlanRequest,
    options?: RequestInit | undefined
  ): Promise<GenerateCablingPlanResponse> => {
    return ReST.post(
      `/api/v1/cablingPlans`,
      generatePayload(request, GenerateCablingPlanRequest),
      options
    ).then((response) => response.json())
      .then(GenerateCablingPlanResponse.fromJSON);
  },
  generateCablingPlanForFabric: (
    request: GenerateCablingPlanRequest,
    options?: RequestInit | undefined
  ): Promise<GenerateCablingPlanResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    return ReST.put(
      `/api/v1/fabrics/${request.fabricId}/cablingPlans`,
      generatePayload(request, GenerateCablingPlanRequest),
      options
    ).then((response) => response.json())
      .then(GenerateCablingPlanResponse.fromJSON);
  },
  getCablingPlan: (
    request: GetCablingPlanRequest,
    options?: RequestInit | undefined
  ): Promise<GetCablingPlanResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId"]
    );
    return ReST.get(
      `/api/v1/fabrics/${request.fabricId}/cablingPlans${queryParams}`,
      options
    ).then((response) => response.json())
      .then(GetCablingPlanResponse.fromJSON);
  },
  addFabricWithDesign: (
    request: AddFabricWithDesignRequest,
    options?: RequestInit | undefined
  ): Promise<AddFabricWithDesignResponse> => {
    return ReST.post(
      `/ui/v1/fabrics`,
      generatePayload(request, AddFabricWithDesignRequest),
      options
    ).then((response) => response.json())
      .then(AddFabricWithDesignResponse.fromJSON);
  },
  updateFabricWithDesign: (
    request: UpdateFabricWithDesignRequest,
    options?: RequestInit | undefined
  ): Promise<Fabric> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    return ReST.put(
      `/ui/v1/fabrics/${request.fabricId}`,
      generatePayload(request, UpdateFabricWithDesignRequest),
      options
    ).then((response) => response.json())
      .then(Fabric.fromJSON);
  },
  addFabrics: (
    request: AddFabricsRequest,
    options?: RequestInit | undefined
  ): Promise<AddFabricsResponse> => {
    return ReST.post(
      `/api/v1/fabrics`,
      generatePayload(request, AddFabricsRequest),
      options
    ).then((response) => response.json())
      .then(AddFabricsResponse.fromJSON);
  },
  updateFabric: (
    request: UpdateFabricRequest,
    options?: RequestInit | undefined
  ): Promise<Fabric> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Body Annotation Field
    if (!request.fabric) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabric is invalid.")
      );
    }
    return ReST.put(
      `/api/v1/fabrics/${request.fabricId}`,
      generatePayload(request, Fabric, "fabric"),
      options
    ).then((response) => response.json())
      .then(Fabric.fromJSON);
  },
  cloneFabric: (
    request: CloneFabricRequest,
    options?: RequestInit | undefined
  ): Promise<CloneFabricResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    return ReST.post(
      `/api/v1/fabrics/${request.fabricId}/clones`,
      generatePayload(request, CloneFabricRequest),
      options
    ).then((response) => response.json())
      .then(CloneFabricResponse.fromJSON);
  },
  deleteFabric: (
    request: DeleteFabricRequest,
    options?: RequestInit | undefined
  ): Promise<Response> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId"]
    );
    return ReST.delete(
      `/api/v1/fabrics/${request.fabricId}${queryParams}`,
      options
    );
  },
  getFabricNodes: (
    request: GetFabricNodesRequest,
    options?: RequestInit | undefined
  ): Promise<GetFabricNodesResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId"]
    );
    return ReST.get(
      `/api/v1/fabrics/${request.fabricId}/nodes${queryParams}`,
      options
    ).then((response) => response.json())
      .then(GetFabricNodesResponse.fromJSON);
  },
  getNamedFabricNode: (
    request: GetNamedFabricNodeRequest,
    options?: RequestInit | undefined
  ): Promise<Node> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: nodeId
    if (!request.nodeId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.nodeId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId", "nodeId"]
    );
    return ReST.get(
      `/api/v1/fabrics/${request.fabricId}/nodes/${request.nodeId}${queryParams}`,
      options
    ).then((response) => response.json())
      .then(Node.fromJSON);
  },
  addFabricNodes: (
    request: AddFabricNodesRequest,
    options?: RequestInit | undefined
  ): Promise<AddFabricNodesResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    return ReST.post(
      `/api/v1/fabrics/${request.fabricId}/nodes`,
      generatePayload(request, AddFabricNodesRequest),
      options
    ).then((response) => response.json())
      .then(AddFabricNodesResponse.fromJSON);
  },
  updateFabricNode: (
    request: UpdateFabricNodeRequest,
    options?: RequestInit | undefined
  ): Promise<Node> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: nodeId
    if (!request.nodeId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.nodeId is invalid.")
      );
    }
    //Validate Body Annotation Field
    if (!request.node) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.node is invalid.")
      );
    }
    return ReST.put(
      `/api/v1/fabrics/${request.fabricId}/nodes/${request.nodeId}`,
      generatePayload(request, Node, "node"),
      options
    ).then((response) => response.json())
      .then(Node.fromJSON);
  },
  deleteFabricNode: (
    request: DeleteFabricNodeRequest,
    options?: RequestInit | undefined
  ): Promise<Response> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: nodeId
    if (!request.nodeId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.nodeId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId", "nodeId"]
    );
    return ReST.delete(
      `/api/v1/fabrics/${request.fabricId}/nodes/${request.nodeId}${queryParams}`,
      options
    );
  },
  getFabricConnections: (
    request: GetFabricConnectionsRequest,
    options?: RequestInit | undefined
  ): Promise<FabricConnectionsResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId"]
    );
    return ReST.get(
      `/api/v1/fabrics/${request.fabricId}/connections${queryParams}`,
      options
    ).then((response) => response.json())
      .then(FabricConnectionsResponse.fromJSON);
  },
  getFabricConnection: (
    request: GetFabricConnectionRequest,
    options?: RequestInit | undefined
  ): Promise<PortConnection> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: connectionId
    if (!request.connectionId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.connectionId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId", "connectionId"]
    );
    return ReST.get(
      `/api/v1/fabrics/${request.fabricId}/connections/${request.connectionId}${queryParams}`,
      options
    ).then((response) => response.json())
      .then(PortConnection.fromJSON);
  },
  deleteFabricConnections: (
    request: DeleteFabricConnectionsRequest,
    options?: RequestInit | undefined
  ): Promise<Response> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId"]
    );
    return ReST.delete(
      `/api/v1/fabrics/${request.fabricId}/connections${queryParams}`,
      options
    );
  },
  deleteFabricConnection: (
    request: DeleteFabricConnectionRequest,
    options?: RequestInit | undefined
  ): Promise<Response> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: connectionId
    if (!request.connectionId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.connectionId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId", "connectionId"]
    );
    return ReST.delete(
      `/api/v1/fabrics/${request.fabricId}/connections/${request.connectionId}${queryParams}`,
      options
    );
  },
  setFabricConnections: (
    request: SetFabricConnectionsRequest,
    options?: RequestInit | undefined
  ): Promise<FabricConnectionsResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    return ReST.put(
      `/api/v1/fabrics/${request.fabricId}/connections`,
      generatePayload(request, SetFabricConnectionsRequest),
      options
    ).then((response) => response.json())
      .then(FabricConnectionsResponse.fromJSON);
  },
  addFabricConnections: (
    request: AddFabricConnectionsRequest,
    options?: RequestInit | undefined
  ): Promise<FabricConnectionsResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    return ReST.post(
      `/api/v1/fabrics/${request.fabricId}/connections`,
      generatePayload(request, AddFabricConnectionsRequest),
      options
    ).then((response) => response.json())
      .then(FabricConnectionsResponse.fromJSON);
  },
  getFabricBgpPeers: (
    request: GetFabricBgpPeersRequest,
    options?: RequestInit | undefined
  ): Promise<FabricBgpPeersResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId"]
    );
    return ReST.get(
      `/api/v1/fabrics/${request.fabricId}/bgpPeers${queryParams}`,
      options
    ).then((response) => response.json())
      .then(FabricBgpPeersResponse.fromJSON);
  },
  getFabricBgpPeer: (
    request: GetFabricBgpPeerRequest,
    options?: RequestInit | undefined
  ): Promise<BgpPeer> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: peerId
    if (!request.peerId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.peerId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId", "peerId"]
    );
    return ReST.get(
      `/api/v1/fabrics/${request.fabricId}/bgpPeers/${request.peerId}${queryParams}`,
      options
    ).then((response) => response.json())
      .then(BgpPeer.fromJSON);
  },
  addFabricBgpPeers: (
    request: AddFabricBgpPeersRequest,
    options?: RequestInit | undefined
  ): Promise<FabricBgpPeersResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    return ReST.post(
      `/api/v1/fabrics/${request.fabricId}/bgpPeers`,
      generatePayload(request, AddFabricBgpPeersRequest),
      options
    ).then((response) => response.json())
      .then(FabricBgpPeersResponse.fromJSON);
  },
  updateFabricBgpPeer: (
    request: UpdateFabricBgpPeerRequest,
    options?: RequestInit | undefined
  ): Promise<BgpPeer> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: peerId
    if (!request.peerId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.peerId is invalid.")
      );
    }
    //Validate Body Annotation Field
    if (!request.peer) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.peer is invalid.")
      );
    }
    return ReST.put(
      `/api/v1/fabrics/${request.fabricId}/bgpPeers/${request.peerId}`,
      generatePayload(request, BgpPeer, "peer"),
      options
    ).then((response) => response.json())
      .then(BgpPeer.fromJSON);
  },
  deleteFabricBgpPeer: (
    request: DeleteFabricBgpPeerRequest,
    options?: RequestInit | undefined
  ): Promise<Response> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: peerId
    if (!request.peerId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.peerId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId", "peerId"]
    );
    return ReST.delete(
      `/api/v1/fabrics/${request.fabricId}/bgpPeers/${request.peerId}${queryParams}`,
      options
    );
  },
  getOspfPeers: (
    request: GetOspfPeersRequest,
    options?: RequestInit | undefined
  ): Promise<TenantsObjectsResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId"]
    );
    return ReST.get(
      `/ui/v1/fabrics/${request.fabricId}/ospfPeers${queryParams}`,
      options
    ).then((response) => response.json())
      .then(TenantsObjectsResponse.fromJSON);
  },
  getFabricBgpPolicies: (
    request: GetFabricBgpPoliciesRequest,
    options?: RequestInit | undefined
  ): Promise<FabricBgpPoliciesResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId"]
    );
    return ReST.get(
      `/api/v1/fabrics/${request.fabricId}/bgpPolicies${queryParams}`,
      options
    ).then((response) => response.json())
      .then(FabricBgpPoliciesResponse.fromJSON);
  },
  getFabricBgpPolicy: (
    request: GetFabricBgpPolicyRequest,
    options?: RequestInit | undefined
  ): Promise<BgpPolicy> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: policyId
    if (!request.policyId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.policyId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId", "policyId"]
    );
    return ReST.get(
      `/api/v1/fabrics/${request.fabricId}/bgpPolicies/${request.policyId}${queryParams}`,
      options
    ).then((response) => response.json())
      .then(BgpPolicy.fromJSON);
  },
  addFabricBgpPolicies: (
    request: AddFabricBgpPoliciesRequest,
    options?: RequestInit | undefined
  ): Promise<FabricBgpPoliciesResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    return ReST.post(
      `/api/v1/fabrics/${request.fabricId}/bgpPolicies`,
      generatePayload(request, AddFabricBgpPoliciesRequest),
      options
    ).then((response) => response.json())
      .then(FabricBgpPoliciesResponse.fromJSON);
  },
  updateFabricBgpPolicy: (
    request: UpdateFabricBgpPolicyRequest,
    options?: RequestInit | undefined
  ): Promise<BgpPolicy> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: policyId
    if (!request.policyId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.policyId is invalid.")
      );
    }
    //Validate Body Annotation Field
    if (!request.policy) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.policy is invalid.")
      );
    }
    return ReST.put(
      `/api/v1/fabrics/${request.fabricId}/bgpPolicies/${request.policyId}`,
      generatePayload(request, BgpPolicy, "policy"),
      options
    ).then((response) => response.json())
      .then(BgpPolicy.fromJSON);
  },
  deleteFabricBgpPolicy: (
    request: DeleteFabricBgpPolicyRequest,
    options?: RequestInit | undefined
  ): Promise<Response> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: policyId
    if (!request.policyId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.policyId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId", "policyId"]
    );
    return ReST.delete(
      `/api/v1/fabrics/${request.fabricId}/bgpPolicies/${request.policyId}${queryParams}`,
      options
    );
  },
  getPrefixLists: (
    request: GetPrefixListsRequest,
    options?: RequestInit | undefined
  ): Promise<GetPrefixListsResponse> => {
    //Generate query params
    const queryParams = generateQueryParams(
      request
    );
    return ReST.get(
      `/ui/v1/prefixLists${queryParams}`,
      options
    ).then((response) => response.json())
      .then(GetPrefixListsResponse.fromJSON);
  },
  getNodePortBreakouts: (
    request: GetNodePortBreakoutsRequest,
    options?: RequestInit | undefined
  ): Promise<NodePortBreakoutsResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: nodeId
    if (!request.nodeId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.nodeId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId", "nodeId"]
    );
    return ReST.get(
      `/api/v1/fabrics/${request.fabricId}/nodes/${request.nodeId}/breakouts${queryParams}`,
      options
    ).then((response) => response.json())
      .then(NodePortBreakoutsResponse.fromJSON);
  },
  getNodePortBreakout: (
    request: GetNodePortBreakoutRequest,
    options?: RequestInit | undefined
  ): Promise<PortBreakout> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: nodeId
    if (!request.nodeId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.nodeId is invalid.")
      );
    }
    //Validate Path Param: breakoutId
    if (!request.breakoutId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.breakoutId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId", "nodeId", "breakoutId"]
    );
    return ReST.get(
      `/api/v1/fabrics/${request.fabricId}/nodes/${request.nodeId}/breakouts/${request.breakoutId}${queryParams}`,
      options
    ).then((response) => response.json())
      .then(PortBreakout.fromJSON);
  },
  addNodePortBreakouts: (
    request: AddNodePortBreakoutsRequest,
    options?: RequestInit | undefined
  ): Promise<NodePortBreakoutsResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: nodeId
    if (!request.nodeId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.nodeId is invalid.")
      );
    }
    return ReST.post(
      `/api/v1/fabrics/${request.fabricId}/nodes/${request.nodeId}/breakouts`,
      generatePayload(request, AddNodePortBreakoutsRequest),
      options
    ).then((response) => response.json())
      .then(NodePortBreakoutsResponse.fromJSON);
  },
  updateNodePortBreakout: (
    request: UpdateNodePortBreakoutRequest,
    options?: RequestInit | undefined
  ): Promise<PortBreakout> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: nodeId
    if (!request.nodeId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.nodeId is invalid.")
      );
    }
    //Validate Path Param: breakoutId
    if (!request.breakoutId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.breakoutId is invalid.")
      );
    }
    //Validate Body Annotation Field
    if (!request.breakout) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.breakout is invalid.")
      );
    }
    return ReST.put(
      `/api/v1/fabrics/${request.fabricId}/nodes/${request.nodeId}/breakouts/${request.breakoutId}`,
      generatePayload(request, PortBreakout, "breakout"),
      options
    ).then((response) => response.json())
      .then(PortBreakout.fromJSON);
  },
  deleteNodePortBreakout: (
    request: DeleteNodePortBreakoutRequest,
    options?: RequestInit | undefined
  ): Promise<Response> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: nodeId
    if (!request.nodeId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.nodeId is invalid.")
      );
    }
    //Validate Path Param: breakoutId
    if (!request.breakoutId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.breakoutId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId", "nodeId", "breakoutId"]
    );
    return ReST.delete(
      `/api/v1/fabrics/${request.fabricId}/nodes/${request.nodeId}/breakouts/${request.breakoutId}${queryParams}`,
      options
    );
  },
  getManagementPorts: (
    request: GetManagementPortsRequest,
    options?: RequestInit | undefined
  ): Promise<ManagementPortsResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: nodeId
    if (!request.nodeId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.nodeId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId", "nodeId"]
    );
    return ReST.get(
      `/api/v1/fabrics/${request.fabricId}/nodes/${request.nodeId}/managementPorts${queryParams}`,
      options
    ).then((response) => response.json())
      .then(ManagementPortsResponse.fromJSON);
  },
  getManagementPort: (
    request: GetManagementPortRequest,
    options?: RequestInit | undefined
  ): Promise<ManagementPort> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: nodeId
    if (!request.nodeId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.nodeId is invalid.")
      );
    }
    //Validate Path Param: id
    if (!request.id) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.id is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId", "nodeId", "id"]
    );
    return ReST.get(
      `/api/v1/fabrics/${request.fabricId}/nodes/${request.nodeId}/managementPorts/${request.id}${queryParams}`,
      options
    ).then((response) => response.json())
      .then(ManagementPort.fromJSON);
  },
  addManagementPorts: (
    request: AddManagementPortsRequest,
    options?: RequestInit | undefined
  ): Promise<ManagementPortsResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: nodeId
    if (!request.nodeId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.nodeId is invalid.")
      );
    }
    return ReST.post(
      `/api/v1/fabrics/${request.fabricId}/nodes/${request.nodeId}/managementPorts`,
      generatePayload(request, AddManagementPortsRequest),
      options
    ).then((response) => response.json())
      .then(ManagementPortsResponse.fromJSON);
  },
  updateManagementPort: (
    request: UpdateManagementPortRequest,
    options?: RequestInit | undefined
  ): Promise<ManagementPort> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: nodeId
    if (!request.nodeId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.nodeId is invalid.")
      );
    }
    //Validate Path Param: id
    if (!request.id) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.id is invalid.")
      );
    }
    //Validate Body Annotation Field
    if (!request.port) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.port is invalid.")
      );
    }
    return ReST.put(
      `/api/v1/fabrics/${request.fabricId}/nodes/${request.nodeId}/managementPorts/${request.id}`,
      generatePayload(request, ManagementPort, "port"),
      options
    ).then((response) => response.json())
      .then(ManagementPort.fromJSON);
  },
  resetManagementPort: (
    request: ResetManagementPortRequest,
    options?: RequestInit | undefined
  ): Promise<Response> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: nodeId
    if (!request.nodeId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.nodeId is invalid.")
      );
    }
    //Validate Path Param: id
    if (!request.id) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.id is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId", "nodeId", "id"]
    );
    return ReST.delete(
      `/api/v1/fabrics/${request.fabricId}/nodes/${request.nodeId}/managementPorts/${request.id}${queryParams}`,
      options
    );
  },
  getPorts: (
    request: GetPortsRequest,
    options?: RequestInit | undefined
  ): Promise<PortsResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: nodeId
    if (!request.nodeId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.nodeId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId", "nodeId"]
    );
    return ReST.get(
      `/api/v1/fabrics/${request.fabricId}/nodes/${request.nodeId}/ports${queryParams}`,
      options
    ).then((response) => response.json())
      .then(PortsResponse.fromJSON);
  },
  setPorts: (
    request: SetPortsRequest,
    options?: RequestInit | undefined
  ): Promise<PortsResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: nodeId
    if (!request.nodeId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.nodeId is invalid.")
      );
    }
    return ReST.put(
      `/api/v1/fabrics/${request.fabricId}/nodes/${request.nodeId}/ports`,
      generatePayload(request, SetPortsRequest),
      options
    ).then((response) => response.json())
      .then(PortsResponse.fromJSON);
  },
  getPort: (
    request: GetPortRequest,
    options?: RequestInit | undefined
  ): Promise<NetworkPort> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: nodeId
    if (!request.nodeId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.nodeId is invalid.")
      );
    }
    //Validate Path Param: portId
    if (!request.portId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.portId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId", "nodeId", "portId"]
    );
    return ReST.get(
      `/api/v1/fabrics/${request.fabricId}/nodes/${request.nodeId}/ports/${request.portId}${queryParams}`,
      options
    ).then((response) => response.json())
      .then(NetworkPort.fromJSON);
  },
  updatePort: (
    request: UpdatePortRequest,
    options?: RequestInit | undefined
  ): Promise<NetworkPort> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: nodeId
    if (!request.nodeId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.nodeId is invalid.")
      );
    }
    //Validate Path Param: portId
    if (!request.portId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.portId is invalid.")
      );
    }
    //Validate Body Annotation Field
    if (!request.port) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.port is invalid.")
      );
    }
    return ReST.put(
      `/api/v1/fabrics/${request.fabricId}/nodes/${request.nodeId}/ports/${request.portId}`,
      generatePayload(request, NetworkPort, "port"),
      options
    ).then((response) => response.json())
      .then(NetworkPort.fromJSON);
  },
  resetPort: (
    request: ResetPortRequest,
    options?: RequestInit | undefined
  ): Promise<Response> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: nodeId
    if (!request.nodeId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.nodeId is invalid.")
      );
    }
    //Validate Path Param: portId
    if (!request.portId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.portId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId", "nodeId", "portId"]
    );
    return ReST.delete(
      `/api/v1/fabrics/${request.fabricId}/nodes/${request.nodeId}/ports/${request.portId}${queryParams}`,
      options
    );
  },
  bindDevice: (
    request: BindDeviceRequest,
    options?: RequestInit | undefined
  ): Promise<BindDeviceResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: nodeId
    if (!request.nodeId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.nodeId is invalid.")
      );
    }
    //Validate Path Param: deviceId
    if (!request.deviceId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.deviceId is invalid.")
      );
    }
    return ReST.put(
      `/api/v1/fabrics/${request.fabricId}/nodes/${request.nodeId}/devices/${request.deviceId}`,
      generatePayload(request, BindDeviceRequest),
      options
    ).then((response) => response.json())
      .then(BindDeviceResponse.fromJSON);
  },
  unbindDevice: (
    request: UnbindDeviceRequest,
    options?: RequestInit | undefined
  ): Promise<Response> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: nodeId
    if (!request.nodeId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.nodeId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId", "nodeId"]
    );
    return ReST.delete(
      `/api/v1/fabrics/${request.fabricId}/nodes/${request.nodeId}/devices${queryParams}`,
      options
    );
  },
  getNodeSubInterfaces: (
    request: GetNodeSubInterfacesRequest,
    options?: RequestInit | undefined
  ): Promise<NodeSubInterfacesResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: nodeId
    if (!request.nodeId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.nodeId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId", "nodeId"]
    );
    return ReST.get(
      `/api/v1/fabrics/${request.fabricId}/nodes/${request.nodeId}/subInterfaces${queryParams}`,
      options
    ).then((response) => response.json())
      .then(NodeSubInterfacesResponse.fromJSON);
  },
  getNodeSubInterface: (
    request: GetNodeSubInterfaceRequest,
    options?: RequestInit | undefined
  ): Promise<SubInterface> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: nodeId
    if (!request.nodeId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.nodeId is invalid.")
      );
    }
    //Validate Path Param: subInterfaceId
    if (!request.subInterfaceId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.subInterfaceId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId", "nodeId", "subInterfaceId"]
    );
    return ReST.get(
      `/api/v1/fabrics/${request.fabricId}/nodes/${request.nodeId}/subInterfaces/${request.subInterfaceId}${queryParams}`,
      options
    ).then((response) => response.json())
      .then(SubInterface.fromJSON);
  },
  addNodeSubInterfaces: (
    request: AddNodeSubInterfacesRequest,
    options?: RequestInit | undefined
  ): Promise<NodeSubInterfacesResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: nodeId
    if (!request.nodeId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.nodeId is invalid.")
      );
    }
    return ReST.post(
      `/api/v1/fabrics/${request.fabricId}/nodes/${request.nodeId}/subInterfaces`,
      generatePayload(request, AddNodeSubInterfacesRequest),
      options
    ).then((response) => response.json())
      .then(NodeSubInterfacesResponse.fromJSON);
  },
  updateNodeSubInterface: (
    request: UpdateNodeSubInterfaceRequest,
    options?: RequestInit | undefined
  ): Promise<SubInterface> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: nodeId
    if (!request.nodeId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.nodeId is invalid.")
      );
    }
    //Validate Path Param: subInterfaceId
    if (!request.subInterfaceId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.subInterfaceId is invalid.")
      );
    }
    //Validate Body Annotation Field
    if (!request.subInterface) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.subInterface is invalid.")
      );
    }
    return ReST.put(
      `/api/v1/fabrics/${request.fabricId}/nodes/${request.nodeId}/subInterfaces/${request.subInterfaceId}`,
      generatePayload(request, SubInterface, "subInterface"),
      options
    ).then((response) => response.json())
      .then(SubInterface.fromJSON);
  },
  deleteNodeSubInterface: (
    request: DeleteNodeSubInterfaceRequest,
    options?: RequestInit | undefined
  ): Promise<Response> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: nodeId
    if (!request.nodeId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.nodeId is invalid.")
      );
    }
    //Validate Path Param: subInterfaceId
    if (!request.subInterfaceId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.subInterfaceId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId", "nodeId", "subInterfaceId"]
    );
    return ReST.delete(
      `/api/v1/fabrics/${request.fabricId}/nodes/${request.nodeId}/subInterfaces/${request.subInterfaceId}${queryParams}`,
      options
    );
  },
  getFabricVnis: (
    request: GetFabricVnisRequest,
    options?: RequestInit | undefined
  ): Promise<FabricVnisResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId"]
    );
    return ReST.get(
      `/api/v1/fabrics/${request.fabricId}/vnis${queryParams}`,
      options
    ).then((response) => response.json())
      .then(FabricVnisResponse.fromJSON);
  },
  getFabricVni: (
    request: GetFabricVniRequest,
    options?: RequestInit | undefined
  ): Promise<Vni> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: vniId
    if (!request.vniId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.vniId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId", "vniId"]
    );
    return ReST.get(
      `/api/v1/fabrics/${request.fabricId}/vnis/${request.vniId}${queryParams}`,
      options
    ).then((response) => response.json())
      .then(Vni.fromJSON);
  },
  addFabricVnis: (
    request: AddFabricVnisRequest,
    options?: RequestInit | undefined
  ): Promise<FabricVnisResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    return ReST.post(
      `/api/v1/fabrics/${request.fabricId}/vnis`,
      generatePayload(request, AddFabricVnisRequest),
      options
    ).then((response) => response.json())
      .then(FabricVnisResponse.fromJSON);
  },
  updateFabricVni: (
    request: UpdateFabricVniRequest,
    options?: RequestInit | undefined
  ): Promise<Vni> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: vniId
    if (!request.vniId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.vniId is invalid.")
      );
    }
    //Validate Body Annotation Field
    if (!request.vni) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.vni is invalid.")
      );
    }
    return ReST.put(
      `/api/v1/fabrics/${request.fabricId}/vnis/${request.vniId}`,
      generatePayload(request, Vni, "vni"),
      options
    ).then((response) => response.json())
      .then(Vni.fromJSON);
  },
  deleteFabricVni: (
    request: DeleteFabricVniRequest,
    options?: RequestInit | undefined
  ): Promise<Response> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: vniId
    if (!request.vniId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.vniId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId", "vniId"]
    );
    return ReST.delete(
      `/api/v1/fabrics/${request.fabricId}/vnis/${request.vniId}${queryParams}`,
      options
    );
  },
  getFabricVniMembers: (
    request: GetFabricVniMembersRequest,
    options?: RequestInit | undefined
  ): Promise<GetFabricVniMembersResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: vniId
    if (!request.vniId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.vniId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId", "vniId"]
    );
    return ReST.get(
      `/api/v1/fabrics/${request.fabricId}/vnis/${request.vniId}/members${queryParams}`,
      options
    ).then((response) => response.json())
      .then(GetFabricVniMembersResponse.fromJSON);
  },
  getFabricVniMember: (
    request: GetFabricVniMemberRequest,
    options?: RequestInit | undefined
  ): Promise<VlanMember> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: vniId
    if (!request.vniId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.vniId is invalid.")
      );
    }
    //Validate Path Param: memberId
    if (!request.memberId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.memberId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId", "vniId", "memberId"]
    );
    return ReST.get(
      `/api/v1/fabrics/${request.fabricId}/vnis/${request.vniId}/members/${request.memberId}${queryParams}`,
      options
    ).then((response) => response.json())
      .then(VlanMember.fromJSON);
  },
  addFabricVniMembers: (
    request: AddFabricVniMembersRequest,
    options?: RequestInit | undefined
  ): Promise<GetFabricVniMembersResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: vniId
    if (!request.vniId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.vniId is invalid.")
      );
    }
    return ReST.post(
      `/api/v1/fabrics/${request.fabricId}/vnis/${request.vniId}/members`,
      generatePayload(request, AddFabricVniMembersRequest),
      options
    ).then((response) => response.json())
      .then(GetFabricVniMembersResponse.fromJSON);
  },
  deleteFabricVniMember: (
    request: DeleteFabricVniMemberRequest,
    options?: RequestInit | undefined
  ): Promise<Response> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: vniId
    if (!request.vniId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.vniId is invalid.")
      );
    }
    //Validate Path Param: memberId
    if (!request.memberId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.memberId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId", "vniId", "memberId"]
    );
    return ReST.delete(
      `/api/v1/fabrics/${request.fabricId}/vnis/${request.vniId}/members/${request.memberId}${queryParams}`,
      options
    );
  },
  getFabricVrfs: (
    request: GetFabricVrfsRequest,
    options?: RequestInit | undefined
  ): Promise<FabricVrfsResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId"]
    );
    return ReST.get(
      `/api/v1/fabrics/${request.fabricId}/vrfs${queryParams}`,
      options
    ).then((response) => response.json())
      .then(FabricVrfsResponse.fromJSON);
  },
  getFabricVrf: (
    request: GetFabricVrfRequest,
    options?: RequestInit | undefined
  ): Promise<Vrf> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: vrfId
    if (!request.vrfId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.vrfId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId", "vrfId"]
    );
    return ReST.get(
      `/api/v1/fabrics/${request.fabricId}/vrfs/${request.vrfId}${queryParams}`,
      options
    ).then((response) => response.json())
      .then(Vrf.fromJSON);
  },
  addFabricVrfs: (
    request: AddFabricVrfsRequest,
    options?: RequestInit | undefined
  ): Promise<FabricVrfsResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    return ReST.post(
      `/api/v1/fabrics/${request.fabricId}/vrfs`,
      generatePayload(request, AddFabricVrfsRequest),
      options
    ).then((response) => response.json())
      .then(FabricVrfsResponse.fromJSON);
  },
  updateFabricVrf: (
    request: UpdateFabricVrfRequest,
    options?: RequestInit | undefined
  ): Promise<Vrf> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: vrfId
    if (!request.vrfId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.vrfId is invalid.")
      );
    }
    //Validate Body Annotation Field
    if (!request.vrf) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.vrf is invalid.")
      );
    }
    return ReST.put(
      `/api/v1/fabrics/${request.fabricId}/vrfs/${request.vrfId}`,
      generatePayload(request, Vrf, "vrf"),
      options
    ).then((response) => response.json())
      .then(Vrf.fromJSON);
  },
  deleteFabricVrf: (
    request: DeleteFabricVrfRequest,
    options?: RequestInit | undefined
  ): Promise<Response> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: vrfId
    if (!request.vrfId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.vrfId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId", "vrfId"]
    );
    return ReST.delete(
      `/api/v1/fabrics/${request.fabricId}/vrfs/${request.vrfId}${queryParams}`,
      options
    );
  },
  getFabricStaticRoutes: (
    request: GetFabricStaticRoutesRequest,
    options?: RequestInit | undefined
  ): Promise<FabricStaticRoutesResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: vrfId
    if (!request.vrfId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.vrfId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId", "vrfId"]
    );
    return ReST.get(
      `/api/v1/fabrics/${request.fabricId}/vrfs/${request.vrfId}/staticRoutes${queryParams}`,
      options
    ).then((response) => response.json())
      .then(FabricStaticRoutesResponse.fromJSON);
  },
  getFabricStaticRoute: (
    request: GetFabricStaticRouteRequest,
    options?: RequestInit | undefined
  ): Promise<StaticRoutes> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: vrfId
    if (!request.vrfId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.vrfId is invalid.")
      );
    }
    //Validate Path Param: routeId
    if (!request.routeId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.routeId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId", "vrfId", "routeId"]
    );
    return ReST.get(
      `/api/v1/fabrics/${request.fabricId}/vrfs/${request.vrfId}/staticRoutes/${request.routeId}${queryParams}`,
      options
    ).then((response) => response.json())
      .then(StaticRoutes.fromJSON);
  },
  addFabricStaticRoutes: (
    request: AddFabricStaticRoutesRequest,
    options?: RequestInit | undefined
  ): Promise<FabricStaticRoutesResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: vrfId
    if (!request.vrfId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.vrfId is invalid.")
      );
    }
    return ReST.post(
      `/api/v1/fabrics/${request.fabricId}/vrfs/${request.vrfId}/staticRoutes`,
      generatePayload(request, AddFabricStaticRoutesRequest),
      options
    ).then((response) => response.json())
      .then(FabricStaticRoutesResponse.fromJSON);
  },
  deleteFabricStaticRoute: (
    request: DeleteFabricStaticRouteRequest,
    options?: RequestInit | undefined
  ): Promise<Response> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: vrfId
    if (!request.vrfId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.vrfId is invalid.")
      );
    }
    //Validate Path Param: routeId
    if (!request.routeId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.routeId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId", "vrfId", "routeId"]
    );
    return ReST.delete(
      `/api/v1/fabrics/${request.fabricId}/vrfs/${request.vrfId}/staticRoutes/${request.routeId}${queryParams}`,
      options
    );
  },
  updateFabricStaticRoute: (
    request: UpdateFabricStaticRouteRequest,
    options?: RequestInit | undefined
  ): Promise<StaticRoutes> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: vrfId
    if (!request.vrfId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.vrfId is invalid.")
      );
    }
    //Validate Path Param: routeId
    if (!request.routeId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.routeId is invalid.")
      );
    }
    //Validate Body Annotation Field
    if (!request.staticRoute) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.staticRoute is invalid.")
      );
    }
    return ReST.put(
      `/api/v1/fabrics/${request.fabricId}/vrfs/${request.vrfId}/staticRoutes/${request.routeId}`,
      generatePayload(request, StaticRoutes, "staticRoute"),
      options
    ).then((response) => response.json())
      .then(StaticRoutes.fromJSON);
  },
  getFabricStp: (
    request: GetFabricStpRequest,
    options?: RequestInit | undefined
  ): Promise<PerVlanStp> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId"]
    );
    return ReST.get(
      `/api/v1/fabrics/${request.fabricId}/stp${queryParams}`,
      options
    ).then((response) => response.json())
      .then(PerVlanStp.fromJSON);
  },
  updateFabricStp: (
    request: UpdateFabricStpRequest,
    options?: RequestInit | undefined
  ): Promise<PerVlanStp> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Body Annotation Field
    if (!request.stp) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.stp is invalid.")
      );
    }
    return ReST.put(
      `/api/v1/fabrics/${request.fabricId}/stp`,
      generatePayload(request, PerVlanStp, "stp"),
      options
    ).then((response) => response.json())
      .then(PerVlanStp.fromJSON);
  },
  resetFabricStp: (
    request: ResetFabricStpRequest,
    options?: RequestInit | undefined
  ): Promise<Response> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId"]
    );
    return ReST.delete(
      `/api/v1/fabrics/${request.fabricId}/stp${queryParams}`,
      options
    );
  },
  getFabricDhcpRelays: (
    request: GetFabricDhcpRelaysRequest,
    options?: RequestInit | undefined
  ): Promise<FabricDhcpRelaysResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId"]
    );
    return ReST.get(
      `/api/v1/fabrics/${request.fabricId}/dhcpRelays${queryParams}`,
      options
    ).then((response) => response.json())
      .then(FabricDhcpRelaysResponse.fromJSON);
  },
  getFabricDhcpRelay: (
    request: GetFabricDhcpRelayRequest,
    options?: RequestInit | undefined
  ): Promise<DhcpRelay> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: relayId
    if (!request.relayId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.relayId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId", "relayId"]
    );
    return ReST.get(
      `/api/v1/fabrics/${request.fabricId}/dhcpRelays/${request.relayId}${queryParams}`,
      options
    ).then((response) => response.json())
      .then(DhcpRelay.fromJSON);
  },
  addFabricDhcpRelays: (
    request: AddFabricDhcpRelaysRequest,
    options?: RequestInit | undefined
  ): Promise<FabricDhcpRelaysResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    return ReST.post(
      `/api/v1/fabrics/${request.fabricId}/dhcpRelays`,
      generatePayload(request, AddFabricDhcpRelaysRequest),
      options
    ).then((response) => response.json())
      .then(FabricDhcpRelaysResponse.fromJSON);
  },
  updateFabricDhcpRelay: (
    request: UpdateFabricDhcpRelayRequest,
    options?: RequestInit | undefined
  ): Promise<DhcpRelay> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: relayId
    if (!request.relayId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.relayId is invalid.")
      );
    }
    //Validate Body Annotation Field
    if (!request.relay) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.relay is invalid.")
      );
    }
    return ReST.put(
      `/api/v1/fabrics/${request.fabricId}/dhcpRelays/${request.relayId}`,
      generatePayload(request, DhcpRelay, "relay"),
      options
    ).then((response) => response.json())
      .then(DhcpRelay.fromJSON);
  },
  deleteFabricDhcpRelay: (
    request: DeleteFabricDhcpRelayRequest,
    options?: RequestInit | undefined
  ): Promise<Response> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: relayId
    if (!request.relayId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.relayId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId", "relayId"]
    );
    return ReST.delete(
      `/api/v1/fabrics/${request.fabricId}/dhcpRelays/${request.relayId}${queryParams}`,
      options
    );
  },
  getFabricDscpConfigs: (
    request: GetFabricDscpConfigsRequest,
    options?: RequestInit | undefined
  ): Promise<FabricDscpConfigsResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId"]
    );
    return ReST.get(
      `/api/v1/fabrics/${request.fabricId}/dscpConfigs${queryParams}`,
      options
    ).then((response) => response.json())
      .then(FabricDscpConfigsResponse.fromJSON);
  },
  getFabricDscpConfig: (
    request: GetFabricDscpConfigRequest,
    options?: RequestInit | undefined
  ): Promise<DscpConfig> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: configId
    if (!request.configId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.configId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId", "configId"]
    );
    return ReST.get(
      `/api/v1/fabrics/${request.fabricId}/dscpConfigs/${request.configId}${queryParams}`,
      options
    ).then((response) => response.json())
      .then(DscpConfig.fromJSON);
  },
  addFabricDscpConfigs: (
    request: AddFabricDscpConfigsRequest,
    options?: RequestInit | undefined
  ): Promise<FabricDscpConfigsResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    return ReST.post(
      `/api/v1/fabrics/${request.fabricId}/dscpConfigs`,
      generatePayload(request, AddFabricDscpConfigsRequest),
      options
    ).then((response) => response.json())
      .then(FabricDscpConfigsResponse.fromJSON);
  },
  updateFabricDscpConfig: (
    request: UpdateFabricDscpConfigRequest,
    options?: RequestInit | undefined
  ): Promise<DscpConfig> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: configId
    if (!request.configId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.configId is invalid.")
      );
    }
    //Validate Body Annotation Field
    if (!request.dscpConfig) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.dscpConfig is invalid.")
      );
    }
    return ReST.put(
      `/api/v1/fabrics/${request.fabricId}/dscpConfigs/${request.configId}`,
      generatePayload(request, DscpConfig, "dscpConfig"),
      options
    ).then((response) => response.json())
      .then(DscpConfig.fromJSON);
  },
  deleteFabricDscpConfig: (
    request: DeleteFabricDscpConfigRequest,
    options?: RequestInit | undefined
  ): Promise<Response> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: configId
    if (!request.configId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.configId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId", "configId"]
    );
    return ReST.delete(
      `/api/v1/fabrics/${request.fabricId}/dscpConfigs/${request.configId}${queryParams}`,
      options
    );
  },
  getFabricIpSlaConfigs: (
    request: GetFabricIpSlaConfigsRequest,
    options?: RequestInit | undefined
  ): Promise<FabricIpSlaConfigsResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId"]
    );
    return ReST.get(
      `/api/v1/fabrics/${request.fabricId}/ipSlaConfigs${queryParams}`,
      options
    ).then((response) => response.json())
      .then(FabricIpSlaConfigsResponse.fromJSON);
  },
  getFabricIpSlaConfig: (
    request: GetFabricIpSlaConfigRequest,
    options?: RequestInit | undefined
  ): Promise<IpSlaConfig> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: configId
    if (!request.configId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.configId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId", "configId"]
    );
    return ReST.get(
      `/api/v1/fabrics/${request.fabricId}/ipSlaConfigs/${request.configId}${queryParams}`,
      options
    ).then((response) => response.json())
      .then(IpSlaConfig.fromJSON);
  },
  addFabricIpSlaConfigs: (
    request: AddFabricIpSlaConfigsRequest,
    options?: RequestInit | undefined
  ): Promise<FabricIpSlaConfigsResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    return ReST.post(
      `/api/v1/fabrics/${request.fabricId}/ipSlaConfigs`,
      generatePayload(request, AddFabricIpSlaConfigsRequest),
      options
    ).then((response) => response.json())
      .then(FabricIpSlaConfigsResponse.fromJSON);
  },
  updateFabricIpSlaConfig: (
    request: UpdateFabricIpSlaConfigRequest,
    options?: RequestInit | undefined
  ): Promise<IpSlaConfig> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: configId
    if (!request.configId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.configId is invalid.")
      );
    }
    //Validate Body Annotation Field
    if (!request.ipSlaConfig) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.ipSlaConfig is invalid.")
      );
    }
    return ReST.put(
      `/api/v1/fabrics/${request.fabricId}/ipSlaConfigs/${request.configId}`,
      generatePayload(request, IpSlaConfig, "ipSlaConfig"),
      options
    ).then((response) => response.json())
      .then(IpSlaConfig.fromJSON);
  },
  deleteFabricIpSlaConfig: (
    request: DeleteFabricIpSlaConfigRequest,
    options?: RequestInit | undefined
  ): Promise<Response> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: configId
    if (!request.configId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.configId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId", "configId"]
    );
    return ReST.delete(
      `/api/v1/fabrics/${request.fabricId}/ipSlaConfigs/${request.configId}${queryParams}`,
      options
    );
  },
  getFabricLoopbacks: (
    request: GetFabricLoopbacksRequest,
    options?: RequestInit | undefined
  ): Promise<FabricLoopbacksResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId"]
    );
    return ReST.get(
      `/api/v1/fabrics/${request.fabricId}/loopbacks${queryParams}`,
      options
    ).then((response) => response.json())
      .then(FabricLoopbacksResponse.fromJSON);
  },
  getNodeLoopbacks: (
    request: GetNodeLoopbacksRequest,
    options?: RequestInit | undefined
  ): Promise<NodeLoopbacksResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: nodeId
    if (!request.nodeId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.nodeId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId", "nodeId"]
    );
    return ReST.get(
      `/api/v1/fabrics/${request.fabricId}/nodes/${request.nodeId}/loopbacks${queryParams}`,
      options
    ).then((response) => response.json())
      .then(NodeLoopbacksResponse.fromJSON);
  },
  getNodeLoopback: (
    request: GetNodeLoopbackRequest,
    options?: RequestInit | undefined
  ): Promise<Loopback> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: nodeId
    if (!request.nodeId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.nodeId is invalid.")
      );
    }
    //Validate Path Param: loopbackId
    if (!request.loopbackId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.loopbackId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId", "nodeId", "loopbackId"]
    );
    return ReST.get(
      `/api/v1/fabrics/${request.fabricId}/nodes/${request.nodeId}/loopbacks/${request.loopbackId}${queryParams}`,
      options
    ).then((response) => response.json())
      .then(Loopback.fromJSON);
  },
  addNodeLoopbacks: (
    request: AddNodeLoopbacksRequest,
    options?: RequestInit | undefined
  ): Promise<NodeLoopbacksResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: nodeId
    if (!request.nodeId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.nodeId is invalid.")
      );
    }
    return ReST.post(
      `/api/v1/fabrics/${request.fabricId}/nodes/${request.nodeId}/loopbacks`,
      generatePayload(request, AddNodeLoopbacksRequest),
      options
    ).then((response) => response.json())
      .then(NodeLoopbacksResponse.fromJSON);
  },
  updateNodeLoopback: (
    request: UpdateNodeLoopbackRequest,
    options?: RequestInit | undefined
  ): Promise<Loopback> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: nodeId
    if (!request.nodeId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.nodeId is invalid.")
      );
    }
    //Validate Path Param: loopbackId
    if (!request.loopbackId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.loopbackId is invalid.")
      );
    }
    //Validate Body Annotation Field
    if (!request.loopback) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.loopback is invalid.")
      );
    }
    return ReST.put(
      `/api/v1/fabrics/${request.fabricId}/nodes/${request.nodeId}/loopbacks/${request.loopbackId}`,
      generatePayload(request, Loopback, "loopback"),
      options
    ).then((response) => response.json())
      .then(Loopback.fromJSON);
  },
  deleteNodeLoopback: (
    request: DeleteNodeLoopbackRequest,
    options?: RequestInit | undefined
  ): Promise<Response> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: nodeId
    if (!request.nodeId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.nodeId is invalid.")
      );
    }
    //Validate Path Param: loopbackId
    if (!request.loopbackId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.loopbackId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId", "nodeId", "loopbackId"]
    );
    return ReST.delete(
      `/api/v1/fabrics/${request.fabricId}/nodes/${request.nodeId}/loopbacks/${request.loopbackId}${queryParams}`,
      options
    );
  },
  addFabricSoftwareConfig: (
    request: AddFabricSoftwareConfigRequest,
    options?: RequestInit | undefined
  ): Promise<FabricSoftwareConfig> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    return ReST.post(
      `/api/v1/fabrics/${request.fabricId}/software`,
      generatePayload(request, AddFabricSoftwareConfigRequest),
      options
    ).then((response) => response.json())
      .then(FabricSoftwareConfig.fromJSON);
  },
  updateFabricSoftwareMode: (
    request: UpdateFabricSoftwareModeRequest,
    options?: RequestInit | undefined
  ): Promise<FabricSoftwareConfig> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    return ReST.put(
      `/api/v1/fabrics/${request.fabricId}/software/mode`,
      generatePayload(request, UpdateFabricSoftwareModeRequest),
      options
    ).then((response) => response.json())
      .then(FabricSoftwareConfig.fromJSON);
  },
  updateFabricSoftwareRunningImage: (
    request: UpdateFabricSoftwareRunningImageRequest,
    options?: RequestInit | undefined
  ): Promise<FabricSoftwareConfig> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    return ReST.put(
      `/api/v1/fabrics/${request.fabricId}/software/running`,
      generatePayload(request, UpdateFabricSoftwareRunningImageRequest),
      options
    ).then((response) => response.json())
      .then(FabricSoftwareConfig.fromJSON);
  },
  updateFabricSoftwareTargetImage: (
    request: UpdateFabricSoftwareTargetImageRequest,
    options?: RequestInit | undefined
  ): Promise<FabricSoftwareConfig> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    return ReST.put(
      `/api/v1/fabrics/${request.fabricId}/software/target`,
      generatePayload(request, UpdateFabricSoftwareTargetImageRequest),
      options
    ).then((response) => response.json())
      .then(FabricSoftwareConfig.fromJSON);
  },
  updateFabricSoftwareNodeImages: (
    request: UpdateFabricSoftwareNodeImagesRequest,
    options?: RequestInit | undefined
  ): Promise<FabricSoftwareConfig> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    return ReST.put(
      `/api/v1/fabrics/${request.fabricId}/software/nodes`,
      generatePayload(request, UpdateFabricSoftwareNodeImagesRequest),
      options
    ).then((response) => response.json())
      .then(FabricSoftwareConfig.fromJSON);
  },
  deleteFabricNodeImages: (
    request: DeleteFabricNodeImagesRequest,
    options?: RequestInit | undefined
  ): Promise<Response> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId"]
    );
    return ReST.delete(
      `/api/v1/fabrics/${request.fabricId}/software/nodes${queryParams}`,
      options
    );
  },
  getFabricSoftwareConfig: (
    request: GetFabricSoftwareConfigRequest,
    options?: RequestInit | undefined
  ): Promise<FabricSoftwareConfig> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId"]
    );
    return ReST.get(
      `/api/v1/fabrics/${request.fabricId}/software${queryParams}`,
      options
    ).then((response) => response.json())
      .then(FabricSoftwareConfig.fromJSON);
  },
  deleteFabricSoftwareConfig: (
    request: DeleteFabricSoftwareConfigRequest,
    options?: RequestInit | undefined
  ): Promise<Response> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId"]
    );
    return ReST.delete(
      `/api/v1/fabrics/${request.fabricId}/software${queryParams}`,
      options
    );
  },
  deleteFabricRunningImage: (
    request: DeleteFabricRunningImageRequest,
    options?: RequestInit | undefined
  ): Promise<Response> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId"]
    );
    return ReST.delete(
      `/api/v1/fabrics/${request.fabricId}/software/running${queryParams}`,
      options
    );
  },
  deleteFabricTargetImage: (
    request: DeleteFabricTargetImageRequest,
    options?: RequestInit | undefined
  ): Promise<Response> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId"]
    );
    return ReST.delete(
      `/api/v1/fabrics/${request.fabricId}/software/target${queryParams}`,
      options
    );
  },
  addSwitchGroupSoftwareConfig: (
    request: AddSwitchGroupSoftwareConfigRequest,
    options?: RequestInit | undefined
  ): Promise<SwitchGroupSoftwareConfig> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: switchGroupId
    if (!request.switchGroupId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.switchGroupId is invalid.")
      );
    }
    return ReST.post(
      `/api/v1/fabrics/${request.fabricId}/switchGroups/${request.switchGroupId}/software`,
      generatePayload(request, AddSwitchGroupSoftwareConfigRequest),
      options
    ).then((response) => response.json())
      .then(SwitchGroupSoftwareConfig.fromJSON);
  },
  updateSwitchGroupSoftwareTargetImage: (
    request: UpdateSwitchGroupSoftwareTargetImageRequest,
    options?: RequestInit | undefined
  ): Promise<SwitchGroupSoftwareConfig> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: switchGroupId
    if (!request.switchGroupId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.switchGroupId is invalid.")
      );
    }
    return ReST.put(
      `/api/v1/fabrics/${request.fabricId}/switchGroups/${request.switchGroupId}/software/target`,
      generatePayload(request, UpdateSwitchGroupSoftwareTargetImageRequest),
      options
    ).then((response) => response.json())
      .then(SwitchGroupSoftwareConfig.fromJSON);
  },
  getSwitchGroupSoftwareConfig: (
    request: GetSwitchGroupSoftwareConfigRequest,
    options?: RequestInit | undefined
  ): Promise<SwitchGroupSoftwareConfig> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: switchGroupId
    if (!request.switchGroupId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.switchGroupId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId", "switchGroupId"]
    );
    return ReST.get(
      `/api/v1/fabrics/${request.fabricId}/switchGroups/${request.switchGroupId}/software${queryParams}`,
      options
    ).then((response) => response.json())
      .then(SwitchGroupSoftwareConfig.fromJSON);
  },
  deleteSwitchGroupSoftwareConfig: (
    request: DeleteSwitchGroupSoftwareConfigRequest,
    options?: RequestInit | undefined
  ): Promise<Response> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: switchGroupId
    if (!request.switchGroupId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.switchGroupId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId", "switchGroupId"]
    );
    return ReST.delete(
      `/api/v1/fabrics/${request.fabricId}/switchGroups/${request.switchGroupId}/software${queryParams}`,
      options
    );
  },
  deleteSwitchGroupTargetImage: (
    request: DeleteSwitchGroupTargetImageRequest,
    options?: RequestInit | undefined
  ): Promise<Response> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: switchGroupId
    if (!request.switchGroupId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.switchGroupId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId", "switchGroupId"]
    );
    return ReST.delete(
      `/api/v1/fabrics/${request.fabricId}/switchGroups/${request.switchGroupId}/software/target${queryParams}`,
      options
    );
  },
  upgradeOpticsFirmware: (
    request: UpgradeOpticsFirmwareRequest,
    options?: RequestInit | undefined
  ): Promise<UpgradeOpticsFirmwareResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    return ReST.put(
      `/api/v1/fabrics/${request.fabricId}/software/optics`,
      generatePayload(request, UpgradeOpticsFirmwareRequest),
      options
    ).then((response) => response.json())
      .then(UpgradeOpticsFirmwareResponse.fromJSON);
  },
  getOpticsFirmwareUpdateInfo: (
    request: GetOpticsFirmwareUpdateInfoRequest,
    options?: RequestInit | undefined
  ): Promise<GetOpticsFirmwareUpdateInfoResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId"]
    );
    return ReST.get(
      `/api/v1/fabrics/${request.fabricId}/software/optics${queryParams}`,
      options
    ).then((response) => response.json())
      .then(GetOpticsFirmwareUpdateInfoResponse.fromJSON);
  },
  getDeviceInventories: (
    request: GetDeviceInventoriesRequest,
    options?: RequestInit | undefined
  ): Promise<GetDeviceInventoriesResponse> => {
    //Validate Path Param: deviceId
    if (!request.deviceId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.deviceId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["deviceId"]
    );
    return ReST.get(
      `/ui/v1/devices/${request.deviceId}${queryParams}`,
      options
    ).then((response) => response.json())
      .then(GetDeviceInventoriesResponse.fromJSON);
  },
  getFabricsOnpremConfig: (
    request: AgentConfigRequest,
    options?: RequestInit | undefined
  ): Promise<AgentConfigResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    return ReST.post(
      `/ui/v1/fabrics/${request.fabricId}/onpremConfig`,
      generatePayload(request, AgentConfigRequest),
      options
    ).then((response) => response.json())
      .then(AgentConfigResponse.fromJSON);
  },
  setDevicePlatformInfo: (
    request: SetAgentPlatformInfoRequest,
    options?: RequestInit | undefined
  ): Promise<SetAgentPlatformInfoResponse> => {
    //Validate Path Param: deviceId
    if (!request.deviceId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.deviceId is invalid.")
      );
    }
    return ReST.post(
      `/ui/v1/devices/${request.deviceId}/agentplatform`,
      generatePayload(request, SetAgentPlatformInfoRequest),
      options
    ).then((response) => response.json())
      .then(SetAgentPlatformInfoResponse.fromJSON);
  },
  getSingleCredentials: (
    request: GetSingleCredentialsRequest,
    options?: RequestInit | undefined
  ): Promise<Credentials> => {
    //Validate Path Param: credentialsId
    if (!request.credentialsId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.credentialsId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["credentialsId"]
    );
    return ReST.get(
      `/api/v1/credentials/${request.credentialsId}${queryParams}`,
      options
    ).then((response) => response.json())
      .then(Credentials.fromJSON);
  },
  latchAssertions: (
    request: LatchAssertionsRequest,
    options?: RequestInit | undefined
  ): Promise<AssertionsResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    return ReST.put(
      `/ui/v1/fabrics/${request.fabricId}/assertions`,
      generatePayload(request, LatchAssertionsRequest),
      options
    ).then((response) => response.json())
      .then(AssertionsResponse.fromJSON);
  },
  latchUnlatchAssertions: (
    request: LatchUnlatchAssertionsRequest,
    options?: RequestInit | undefined
  ): Promise<LatchUnlatchAssertionsResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    return ReST.put(
      `/api/v1/fabrics/${request.fabricId}/assertions`,
      generatePayload(request, LatchUnlatchAssertionsRequest),
      options
    ).then((response) => response.json())
      .then(LatchUnlatchAssertionsResponse.fromJSON);
  },
  getRefPoints: (
    request: RefPointByFabricRequest,
    options?: RequestInit | undefined
  ): Promise<RefPointList> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId"]
    );
    return ReST.get(
      `/api/v1/fabrics/${request.fabricId}/refPoints${queryParams}`,
      options
    ).then((response) => response.json())
      .then(RefPointList.fromJSON);
  },
  getRefPoint: (
    request: RefPointByNameRequest,
    options?: RequestInit | undefined
  ): Promise<RefPoint> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: refPointName
    if (!request.refPointName) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.refPointName is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId", "refPointName"]
    );
    return ReST.get(
      `/api/v1/fabrics/${request.fabricId}/refPoints/${request.refPointName}${queryParams}`,
      options
    ).then((response) => response.json())
      .then(RefPoint.fromJSON);
  },
  deleteRefPoint: (
    request: RefPointByNameRequest,
    options?: RequestInit | undefined
  ): Promise<Response> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: refPointName
    if (!request.refPointName) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.refPointName is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId", "refPointName"]
    );
    return ReST.delete(
      `/api/v1/fabrics/${request.fabricId}/refPoints/${request.refPointName}${queryParams}`,
      options
    );
  },
  createProvisionalRefPoint: (
    request: CreateRefPointRequest,
    options?: RequestInit | undefined
  ): Promise<RefPoint> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    return ReST.post(
      `/api/v1/fabrics/${request.fabricId}/refPoints`,
      generatePayload(request, CreateRefPointRequest),
      options
    ).then((response) => response.json())
      .then(RefPoint.fromJSON);
  },
  promoteProvisionalRefPoint: (
    request: RefPointByFabricRequest,
    options?: RequestInit | undefined
  ): Promise<RefPoint> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    return ReST.put(
      `/api/v1/fabrics/${request.fabricId}/refPoints`,
      generatePayload(request, RefPointByFabricRequest),
      options
    ).then((response) => response.json())
      .then(RefPoint.fromJSON);
  },
  createRefPointDiff: (
    request: RefPointByFabricRequest,
    options?: RequestInit | undefined
  ): Promise<RefPoint> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    return ReST.post(
      `/api/v1/fabrics/${request.fabricId}/refPoints/diffs`,
      generatePayload(request, RefPointByFabricRequest),
      options
    ).then((response) => response.json())
      .then(RefPoint.fromJSON);
  },
  getRefPointDiff: (
    request: RefPointByNameRequest,
    options?: RequestInit | undefined
  ): Promise<DiffPart> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: refPointName
    if (!request.refPointName) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.refPointName is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId", "refPointName"]
    );
    return ReST.get(
      `/api/v1/fabrics/${request.fabricId}/refPoints/${request.refPointName}/diffs${queryParams}`,
      options
    ).then((response) => response.json())
      .then(DiffPart.fromJSON);
  },
  exportFabricConfiguration: (
    request: ExportFabricConfigurationRequest,
    options?: RequestInit | undefined
  ): Promise<ExportedFabricConfiguration> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    return ReST.post(
      `/api/v1/fabrics/${request.fabricId}/configurations`,
      generatePayload(request, ExportFabricConfigurationRequest),
      options
    ).then((response) => response.json())
      .then(ExportedFabricConfiguration.fromJSON);
  },
  importFabricConfiguration: (
    request: ExportedFabricConfiguration,
    options?: RequestInit | undefined
  ): Promise<ImportFabricResponse> => {
    return ReST.post(
      `/api/v1/fabrics/configurations`,
      generatePayload(request, ExportedFabricConfiguration),
      options
    ).then((response) => response.json())
      .then(ImportFabricResponse.fromJSON);
  },
  getEntitlementUsage: (
    request: GetEntitlementUsageRequest,
    options?: RequestInit | undefined
  ): Promise<GetEntitlementUsageResponse> => {
    //Generate query params
    const queryParams = generateQueryParams(
      request
    );
    return ReST.get(
      `/api/v1/entitlements${queryParams}`,
      options
    ).then((response) => response.json())
      .then(GetEntitlementUsageResponse.fromJSON);
  },
  restoreFabricRevision: (
    request: RestoreFabricRevisionRequest,
    options?: RequestInit | undefined
  ): Promise<RestoreFabricRevisionResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    return ReST.put(
      `/api/v1/fabrics/${request.fabricId}/revision`,
      generatePayload(request, RestoreFabricRevisionRequest),
      options
    ).then((response) => response.json())
      .then(RestoreFabricRevisionResponse.fromJSON);
  },
  createFabricRevisionExport: (
    request: CreateFabricRevisionExportRequest,
    options?: RequestInit | undefined
  ): Promise<ExportedFabricRevision> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    return ReST.post(
      `/api/v1/fabrics/${request.fabricId}/revision`,
      generatePayload(request, CreateFabricRevisionExportRequest),
      options
    ).then((response) => response.json())
      .then(ExportedFabricRevision.fromJSON);
  },
  getDeletedFabrics: (
    request: GetDeletedFabricsRequest,
    options?: RequestInit | undefined
  ): Promise<GetDeletedFabricsResponse> => {
    //Generate query params
    const queryParams = generateQueryParams(
      request
    );
    return ReST.get(
      `/api/v1/deleted/fabrics${queryParams}`,
      options
    ).then((response) => response.json())
      .then(GetDeletedFabricsResponse.fromJSON);
  },
  createDeletedFabricExport: (
    request: CreateDeletedFabricExportRequest,
    options?: RequestInit | undefined
  ): Promise<ExportedFabricRevision> => {
    return ReST.post(
      `/api/v1/deleted/fabrics`,
      generatePayload(request, CreateDeletedFabricExportRequest),
      options
    ).then((response) => response.json())
      .then(ExportedFabricRevision.fromJSON);
  },
  restoreDeletedFabric: (
    request: RestoreDeletedFabricRequest,
    options?: RequestInit | undefined
  ): Promise<RestoreFabricRevisionResponse> => {
    return ReST.put(
      `/api/v1/deleted/fabrics`,
      generatePayload(request, RestoreDeletedFabricRequest),
      options
    ).then((response) => response.json())
      .then(RestoreFabricRevisionResponse.fromJSON);
  },
  getDciConfigs: (
    request: GetDciConfigsRequest,
    options?: RequestInit | undefined
  ): Promise<GetDciConfigsResponse> => {
    //Generate query params
    const queryParams = generateQueryParams(
      request
    );
    return ReST.get(
      `/api/v1/dcis${queryParams}`,
      options
    ).then((response) => response.json())
      .then(GetDciConfigsResponse.fromJSON);
  },
  getDciCandidates: (
    request: GetDciCandidatesRequest,
    options?: RequestInit | undefined
  ): Promise<GetDciCandidatesResponse> => {
    //Validate Path Param: dciId
    if (!request.dciId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.dciId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["dciId"]
    );
    return ReST.get(
      `/api/v1/dcis/${request.dciId}/candidates${queryParams}`,
      options
    ).then((response) => response.json())
      .then(GetDciCandidatesResponse.fromJSON);
  },
  commitDciCandidate: (
    request: CommitDciCandidateRequest,
    options?: RequestInit | undefined
  ): Promise<CommitDciCandidateResponse> => {
    //Validate Path Param: dciId
    if (!request.dciId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.dciId is invalid.")
      );
    }
    //Validate Path Param: name
    if (!request.name) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.name is invalid.")
      );
    }
    return ReST.put(
      `/api/v1/dcis/${request.dciId}/candidates/${request.name}`,
      generatePayload(request, CommitDciCandidateRequest),
      options
    ).then((response) => response.json())
      .then(CommitDciCandidateResponse.fromJSON);
  },
  revertDciCandidate: (
    request: RevertDciCandidateRequest,
    options?: RequestInit | undefined
  ): Promise<Response> => {
    //Validate Path Param: dciId
    if (!request.dciId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.dciId is invalid.")
      );
    }
    //Validate Path Param: name
    if (!request.name) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.name is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["dciId", "name"]
    );
    return ReST.delete(
      `/api/v1/dcis/${request.dciId}/candidates/${request.name}${queryParams}`,
      options
    );
  },
  reviewDciCandidate: (
    request: ReviewDciCandidateRequest,
    options?: RequestInit | undefined
  ): Promise<Response> => {
    //Validate Path Param: dciId
    if (!request.dciId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.dciId is invalid.")
      );
    }
    //Validate Path Param: name
    if (!request.name) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.name is invalid.")
      );
    }
    return ReST.post(
      `/api/v1/dcis/${request.dciId}/candidates/${request.name}`,
      generatePayload(request, ReviewDciCandidateRequest),
      options
    );
  },
  getFabricMultisites: (
    request: GetFabricMultisitesRequest,
    options?: RequestInit | undefined
  ): Promise<GetFabricMultisitesResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId"]
    );
    return ReST.get(
      `/api/v1/fabrics/${request.fabricId}/multisites${queryParams}`,
      options
    ).then((response) => response.json())
      .then(GetFabricMultisitesResponse.fromJSON);
  },
  addDashboards: (
    request: AddDashboardsRequest,
    options?: RequestInit | undefined
  ): Promise<DashboardsResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: folderId
    if (!request.folderId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.folderId is invalid.")
      );
    }
    return ReST.post(
      `/api/v1/fabrics/${request.fabricId}/dashboardFolders/${request.folderId}/dashboards`,
      generatePayload(request, AddDashboardsRequest),
      options
    ).then((response) => response.json())
      .then(DashboardsResponse.fromJSON);
  },
  getDashboard: (
    request: GetDashboardRequest,
    options?: RequestInit | undefined
  ): Promise<Dashboard> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: folderId
    if (!request.folderId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.folderId is invalid.")
      );
    }
    //Validate Path Param: dashboardId
    if (!request.dashboardId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.dashboardId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId", "folderId", "dashboardId"]
    );
    return ReST.get(
      `/api/v1/fabrics/${request.fabricId}/dashboardFolders/${request.folderId}/dashboards/${request.dashboardId}${queryParams}`,
      options
    ).then((response) => response.json())
      .then(Dashboard.fromJSON);
  },
  getDashboards: (
    request: GetDashboardsRequest,
    options?: RequestInit | undefined
  ): Promise<DashboardsResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: folderId
    if (!request.folderId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.folderId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId", "folderId"]
    );
    return ReST.get(
      `/api/v1/fabrics/${request.fabricId}/dashboardFolders/${request.folderId}/dashboards${queryParams}`,
      options
    ).then((response) => response.json())
      .then(DashboardsResponse.fromJSON);
  },
  updateDashboard: (
    request: UpdateDashboardRequest,
    options?: RequestInit | undefined
  ): Promise<Dashboard> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: folderId
    if (!request.folderId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.folderId is invalid.")
      );
    }
    //Validate Path Param: dashboardId
    if (!request.dashboardId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.dashboardId is invalid.")
      );
    }
    //Validate Body Annotation Field
    if (!request.dashboard) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.dashboard is invalid.")
      );
    }
    return ReST.put(
      `/api/v1/fabrics/${request.fabricId}/dashboardFolders/${request.folderId}/dashboards/${request.dashboardId}`,
      generatePayload(request, Dashboard, "dashboard"),
      options
    ).then((response) => response.json())
      .then(Dashboard.fromJSON);
  },
  deleteDashboard: (
    request: DeleteDashboardRequest,
    options?: RequestInit | undefined
  ): Promise<Response> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: folderId
    if (!request.folderId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.folderId is invalid.")
      );
    }
    //Validate Path Param: dashboardId
    if (!request.dashboardId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.dashboardId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId", "folderId", "dashboardId"]
    );
    return ReST.delete(
      `/api/v1/fabrics/${request.fabricId}/dashboardFolders/${request.folderId}/dashboards/${request.dashboardId}${queryParams}`,
      options
    );
  },
  addFolders: (
    request: AddFoldersRequest,
    options?: RequestInit | undefined
  ): Promise<DashboardFoldersResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    return ReST.post(
      `/api/v1/fabrics/${request.fabricId}/dashboardFolders`,
      generatePayload(request, AddFoldersRequest),
      options
    ).then((response) => response.json())
      .then(DashboardFoldersResponse.fromJSON);
  },
  updateFolder: (
    request: UpdateFolderRequest,
    options?: RequestInit | undefined
  ): Promise<DashboardFolder> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: folderId
    if (!request.folderId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.folderId is invalid.")
      );
    }
    //Validate Body Annotation Field
    if (!request.folder) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.folder is invalid.")
      );
    }
    return ReST.put(
      `/api/v1/fabrics/${request.fabricId}/dashboardFolders/${request.folderId}`,
      generatePayload(request, DashboardFolder, "folder"),
      options
    ).then((response) => response.json())
      .then(DashboardFolder.fromJSON);
  },
  getFolders: (
    request: GetFoldersRequest,
    options?: RequestInit | undefined
  ): Promise<DashboardFoldersResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId"]
    );
    return ReST.get(
      `/api/v1/fabrics/${request.fabricId}/dashboardFolders${queryParams}`,
      options
    ).then((response) => response.json())
      .then(DashboardFoldersResponse.fromJSON);
  },
  addPanels: (
    request: AddPanelsRequest,
    options?: RequestInit | undefined
  ): Promise<DashboardPanels> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: folderId
    if (!request.folderId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.folderId is invalid.")
      );
    }
    //Validate Path Param: dashboardId
    if (!request.dashboardId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.dashboardId is invalid.")
      );
    }
    return ReST.post(
      `/api/v1/fabrics/${request.fabricId}/dashboardFolders/${request.folderId}/dashboards/${request.dashboardId}/panels`,
      generatePayload(request, AddPanelsRequest),
      options
    ).then((response) => response.json())
      .then(DashboardPanels.fromJSON);
  },
  getPanel: (
    request: GetPanelRequest,
    options?: RequestInit | undefined
  ): Promise<DashboardPanel> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: folderId
    if (!request.folderId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.folderId is invalid.")
      );
    }
    //Validate Path Param: dashboardId
    if (!request.dashboardId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.dashboardId is invalid.")
      );
    }
    //Validate Path Param: panelId
    if (!request.panelId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.panelId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId", "folderId", "dashboardId", "panelId"]
    );
    return ReST.get(
      `/api/v1/fabrics/${request.fabricId}/dashboardFolders/${request.folderId}/dashboards/${request.dashboardId}/panels/${request.panelId}${queryParams}`,
      options
    ).then((response) => response.json())
      .then(DashboardPanel.fromJSON);
  },
  getPanels: (
    request: GetPanelsRequest,
    options?: RequestInit | undefined
  ): Promise<DashboardPanels> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: folderId
    if (!request.folderId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.folderId is invalid.")
      );
    }
    //Validate Path Param: dashboardId
    if (!request.dashboardId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.dashboardId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId", "folderId", "dashboardId"]
    );
    return ReST.get(
      `/api/v1/fabrics/${request.fabricId}/dashboardFolders/${request.folderId}/dashboards/${request.dashboardId}/panels${queryParams}`,
      options
    ).then((response) => response.json())
      .then(DashboardPanels.fromJSON);
  },
  updatePanel: (
    request: UpdatePanelRequest,
    options?: RequestInit | undefined
  ): Promise<DashboardPanel> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: folderId
    if (!request.folderId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.folderId is invalid.")
      );
    }
    //Validate Path Param: dashboardId
    if (!request.dashboardId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.dashboardId is invalid.")
      );
    }
    //Validate Path Param: panelId
    if (!request.panelId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.panelId is invalid.")
      );
    }
    //Validate Body Annotation Field
    if (!request.panel) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.panel is invalid.")
      );
    }
    return ReST.put(
      `/api/v1/fabrics/${request.fabricId}/dashboardFolders/${request.folderId}/dashboards/${request.dashboardId}/panels/${request.panelId}`,
      generatePayload(request, Panel, "panel"),
      options
    ).then((response) => response.json())
      .then(DashboardPanel.fromJSON);
  },
  deletePanel: (
    request: DeletePanelRequest,
    options?: RequestInit | undefined
  ): Promise<Response> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: folderId
    if (!request.folderId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.folderId is invalid.")
      );
    }
    //Validate Path Param: dashboardId
    if (!request.dashboardId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.dashboardId is invalid.")
      );
    }
    //Validate Path Param: panelId
    if (!request.panelId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.panelId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId", "folderId", "dashboardId", "panelId"]
    );
    return ReST.delete(
      `/api/v1/fabrics/${request.fabricId}/dashboardFolders/${request.folderId}/dashboards/${request.dashboardId}/panels/${request.panelId}${queryParams}`,
      options
    );
  },
  getQueuedTasks: (
    request: GetQueuedTasksRequest,
    options?: RequestInit | undefined
  ): Promise<GetQueuedTasksResponse> => {
    //Generate query params
    const queryParams = generateQueryParams(
      request
    );
    return ReST.get(
      `/api/v1/queuedTasks${queryParams}`,
      options
    ).then((response) => response.json())
      .then(GetQueuedTasksResponse.fromJSON);
  },
  getQueuedTask: (
    request: GetQueuedTaskRequest,
    options?: RequestInit | undefined
  ): Promise<QueuedTask> => {
    //Validate Path Param: taskId
    if (!request.taskId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.taskId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["taskId"]
    );
    return ReST.get(
      `/api/v1/queuedTasks/${request.taskId}${queryParams}`,
      options
    ).then((response) => response.json())
      .then(QueuedTask.fromJSON);
  },
};

